(function () {

    'use strict';

    angular.module('asys')
        .service('BasisAngebotService', BasisAngebotService);

    BasisAngebotService.$inject = [
        '$rootScope',
        '$log',
        '$injector',
        '$q',
        '$http',
        '$window',
        '$analytics',
        'lodash',
        'modernizr',
        'moment',
        'AppConfig',
        'AngebotModel',
        'MiscUtilsService',
        'SchluesselWerteUtilsService',
        'AuthenticationService',
        'ObjectTypeUtilsService',
        'IntegrationService',
        'IdentityTypeUtilsService',
        'AdresseUtilsService',
        'FormatUtilsService',
        'ApiService',
        'ApiCacheService',
        'BinaryUtilsService',
        'MoneyUtilsService',
        'TrackingUtilsService'
    ];
    function BasisAngebotService($rootScope, $log, $injector, $q, $http, $window, $analytics, _, modernizr, moment, AppConfig, AngebotModel, MiscUtilsService, SchluesselWerteUtilsService, AuthenticationService, ObjectTypeUtilsService, IntegrationService, IdentityTypeUtilsService, AdresseUtilsService, FormatUtilsService, ApiService, ApiCacheService, BinaryUtilsService, MoneyUtilsService, TrackingUtilsService) {
        var that = this,
            CustomAngebotService = initCustomAngebotService(),
            sepaMandatErlaubt = false,
            hinweismeldungDoppelversicherungAngezeigtHash = null,
            CONSTANTS = {
                taetigkeitsschluessel: [
                    SchluesselWerteUtilsService.create('TAETIGKEITSSCHLUESSEL', '0', 'kein Berufsbeamter'),
                    SchluesselWerteUtilsService.create('TAETIGKEITSSCHLUESSEL', '50', 'Berufsbeamter')
                ],
                mitgliedsarten: {
                    privatkunde: SchluesselWerteUtilsService.create('MITGLIEDSART', '61', 'Private Mitglieder'),
                    firmenkunde: SchluesselWerteUtilsService.create('MITGLIEDSART', '49', 'Sonstige Körperschaften nicht ÖD')
                },
                inkassoarten: {
                    abbucher: {
                        wert: 'Abbucher',
                        bezeichnung: 'Lastschrifteinzug'
                    },
                    rechnung: {
                        wert: 'Rechnung',
                        bezeichnung: 'Rechnung'
                    },
                    paypal: {
                        wert: 'PayPal',
                        bezeichnung: 'PayPal'
                    },
                    sofortueberweisung: {
                        wert: 'SofortUeb',
                        bezeichnung: 'Sofortüberweisung'
                    },
                    direktueberweisung: {
                        wert: 'DirektUeb',
                        bezeichnung: 'Direktüberweisung'
                    },
                    kreditkarte: {
                        wert: 'KredKarte',
                        bezeichnung: 'Kreditkarte'
                    }
                },
                kontoinhaber: {
                    versicherungsnehmer: {
                        wert: 'Versicherungsnehmer',
                        bezeichnung: 'Versicherungsnehmer'
                    },
                    anderePerson: {
                        wert: 'AnderePerson',
                        bezeichnung: 'andere Person'
                    }
                },
                vorversicherungsarten: {
                    unternehmen: {
                        wert: 'UNTERNEHMEN',
                        bezeichnung: 'WGV'
                    },
                    fremdversicherung: {
                        wert: 'FREMDVERSICHERUNG',
                        bezeichnung: 'anderer Versicherer'
                    }
                },
                vorversicherungGekuendigtVon: {
                    versicherer: {
                        wert: true,
                        bezeichnung: 'Die Versicherung'
                    },
                    versicherungsnehmer: {
                        wert: false,
                        bezeichnung: 'Ich selbst'
                    }
                },
                druckwege: AppConfig.ANGEBOT.druckwege,
                versicherungsgesellschaften: {
                    wgvHimmelblau: '55250011'
                },
                arbeitgeber: {
                    oeffentlicherDienst: {
                        typ: 'ARBEITGEBER',
                        wert: '1',
                        bezeichnung: 'öffentlicher Dienst (B-Berechtigung)'
                    },
                    sonstigerArbeitgeber: {
                        typ: 'ARBEITGEBER',
                        wert: '20012',
                        bezeichnung: 'Sonstige Arbeitgeber'
                    },
                    selbststaendig: {
                        typ: 'ARBEITGEBER',
                        wert: '27',
                        bezeichnung: 'Selbständig'
                    },
                    keinArbeitgeber: {
                        typ: 'ARBEITGEBER',
                        wert: '22',
                        bezeichnung: 'kein Arbeitgeber'
                    }
                },
                beruf: {
                    ohneBerufsangabe: {
                        typ: 'BERUF',
                        wert: '9999',
                        bezeichnung: 'ohne Berufsangabe'
                    },
                    beamter: {
                        typ: 'BERUF',
                        wert: '1932',
                        bezeichnung: 'Beamter (m/w/d)'
                    },
                    ingenieur: {
                        typ: 'BERUF',
                        wert: '1583',
                        bezeichnung: 'Ingenieure (m/w/d)'
                    },
                    selbststaendig: {
                        typ: 'BERUF',
                        wert: '9997',
                        bezeichnung: 'Selbständige'
                    }
                }
            },
            angebotspartnerPathMap = {
                postempfaenger: 'allgemeineDaten.postempfaenger',
                antragsteller: 'antragsteller',
                praemienzahler: 'zahlungsinformationen.praemienzahler',
                partnerIcis: 'partnerIcis'
            },
            tarifrelevanteAenderungenProperties = [
                'allgemeineDaten.inOeffentlicherVerwaltungTaetig', 'allgemeineDaten.tarifDesEhepartners',
                'antragsteller.postleitzahl', 'antragsteller.arbeitgeber.wert', 'antragsteller.beruf.wert', 'antragsteller.mitgliedsart.wert', 'antragsteller.taetigkeitsschluessel.wert', 'antragsteller.imOeffentlichemDienstTaetig', 'antragsteller.blaulicht.wert', 'antragsteller.netzwerk.wert'
            ],

            beitragsanpassungMessages = [];

        that.speichereServiceInProgress = [];
        that.berechneServiceInProgress = [];
        that.forceBerechnen = false;

        that.resetServiceVariables = resetServiceVariables;
        that.getDIReference = getDIReference;
        that.getAngebotSpezifischNamePrefix = getAngebotSpezifischNamePrefix;
        that.getConstant = getConstant;
        that.getBausteineKeys = getBausteineKeys;
        that.getGegenstaendeKeys = getGegenstaendeKeys;
        that.getBausteine = getBausteine;
        that.getGegenstaende = getGegenstaende;
        that.getBeitraegeGroupedByProduktGruppe = getBeitraegeGroupedByProduktGruppe;
        that.getPreparedBeitragsGegenstaende = getPreparedBeitragsGegenstaende;
        that.getPreparedBeitragsBausteine = getPreparedBeitragsBausteine;
        that.filterBeitraegeByProduktGruppe = filterBeitraegeByProduktGruppe;
        that.getTarifrechnerergebnisZeilen = getTarifrechnerergebnisZeilen;
        that.getStartStep = getStartStep;
        that.getGlobals = getGlobals;
        that.setDefaults = setDefaults;
        that.mapServiceData = mapServiceData;
        that.mapFormToServiceData = mapFormToServiceData;
        that.mapServiceToFormData = mapServiceToFormData;
        that.getTaetigkeitsschluessel = getTaetigkeitsschluessel;
        that.berechne = berechne;
        that.refresh = refresh;
        that.refreshAngebot = refreshAngebot;
        that.refreshMandatUndTarifgruppe = refreshMandatUndTarifgruppe;
        that.refreshZasZapUndSbLg = refreshZasZapUndSbLg;
        that.beitragsanpassung = beitragsanpassung;
        that.speichere = speichere;
        that.loesche = loesche;
        that.erzeugeVertrag = erzeugeVertrag;
        that.antragDrucken = antragDrucken;
        that.antragUebersichtDrucken = antragUebersichtDrucken;
        that.validiere = validiere;
        that.getEKomiLink = getEKomiLink;
        that.prepareAddDateiAnhaenge = prepareAddDateiAnhaenge;
        that.getDateiAnhang = getDateiAnhang;
        that.deleteDateiAnhang = deleteDateiAnhang;
        that.angebotDrucken = angebotDrucken;
        that.checkAvbChanged = checkAvbChanged;
        that.checkSepaMandatAktiv = checkSepaMandatAktiv;
        that.isPrivatPerson = isPrivatPerson;
        that.getAngebotstyp = getAngebotstyp;
        that.getAngebotsnummer = getAngebotsnummer;
        that.getProduktGruppen = getProduktGruppen;
        that.getStatus = getStatus;
        that.setStatus = setStatus;
        that.setStatusNachDruck = setStatusNachDruck;
        that.isAngebotAenderbar = isAngebotAenderbar;
        that.isAntragErfolgreich = isAntragErfolgreich;
        that.beitraegeVorhanden = beitraegeVorhanden;
        that.getToken = getToken;
        that.checkSollBerechnen = checkSollBerechnen;
        that.hatAenderungen = hatAenderungen;
        that.hatTarifrelevanteAenderungen = hatTarifrelevanteAenderungen;
        that.hatAenderungenFuerTarifgruppe = hatAenderungenFuerTarifgruppe;
        that.getTarifrelevanteAenderungProperties = getTarifrelevanteAenderungProperties;
        that.bereinigeAngebotFuerVergleich = bereinigeAngebotFuerVergleich;
        that.getAngebotspartner = getAngebotspartner;
        that.getAngebotspartnerPath = getAngebotspartnerPath;
        that.getKommunikationsmedien = getKommunikationsmedien;
        that.getKommunikationsmedium = getKommunikationsmedium;
        that.setKommunikationsmedium = setKommunikationsmedium;
        that.loescheKommunikationsmedium = loescheKommunikationsmedium;
        that.aktualisiereKommunikationsmedium = aktualisiereKommunikationsmedium;
        that.uebernehmeAngebotspartner = uebernehmeAngebotspartner;
        that.uebernehmeAntragstellerAlsPraemienzaher = uebernehmeAntragstellerAlsPraemienzaher;
        that.loescheAngebotspartner = loescheAngebotspartner;
        that.getMaxAntragstellerGeburtsdatum = getMaxAntragstellerGeburtsdatum;
        that.isAngebotAnonym = isAngebotAnonym;
        that.isPlzAntragstellerEingabeImAngebotVorhanden = isPlzAntragstellerEingabeImAngebotVorhanden;
        that.isDirectNavigationToStepErgebnisErlaubt = isDirectNavigationToStepErgebnisErlaubt;
        that.isHinweismeldungDoppelversicherungAnzeigen = isHinweismeldungDoppelversicherungAnzeigen;
        that.isErsatzgeschaeft = isErsatzgeschaeft;
        that.isDeckungsaenderung = isDeckungsaenderung;
        that.getAvbVersion = getAvbVersion;
        that.isGevo = isGevo;
        that.getAltvertragObjekt = getAltvertragObjekt;
        that.kopiereAngebot = kopiereAngebot;
        that.neuesAngebotMitAntragsteller = neuesAngebotMitAntragsteller;
        that.erstelleNeuesAngebot = erstelleNeuesAngebot;
        that.setDateiAnhang = setDateiAnhang;
        that.removeDateiAnhang = removeDateiAnhang;
        that.getGesamtbeitragZuZahlweise = getGesamtbeitragZuZahlweise;
        that.getMoeglicheZahlweisen = getMoeglicheZahlweisen;
        that.getZahlweise = getZahlweise;
        that.setZahlweise = setZahlweise;
        that.isEinmalZahlung = isEinmalZahlung;
        that.isRechnungBeiZahlweiseErlaubt = isRechnungBeiZahlweiseErlaubt;
        that.korrigiereZahlweise = korrigiereZahlweise;
        that.getMoeglicheTarifarten = getMoeglicheTarifarten;
        that.sortiereTarifarten = sortiereTarifarten;
        that.hasBausteinTarifarten = hasBausteinTarifarten;
        that.getBausteinTarifart = getBausteinTarifart;
        that.setBausteinTarifart = setBausteinTarifart;
        that.aktualisiereTarifart = aktualisiereTarifart;
        that.deaktiviereBausteinTarifartNichtMoeglich = deaktiviereBausteinTarifartNichtMoeglich;
        that.setBausteinAktiv = setBausteinAktiv;
        that.setBausteinSbLg = setBausteinSbLg;
        that.resetBeitraege = resetBeitraege;
        that.resetBaustein = resetBaustein;
        that.resetGegenstand = resetGegenstand;
        that.resetBestandteil = resetBestandteil;
        that.isBausteinAktiv = isBausteinAktiv;
        that.leereInaktiveBausteine = leereInaktiveBausteine;
        that.loescheInaktiveBausteine = loescheInaktiveBausteine;
        that.isTarifartAktiv = isTarifartAktiv;
        that.getDeckungscode = getDeckungscode;
        that.setDeckungscode = setDeckungscode;
        that.getAngebotsdatumRegeln = getAngebotsdatumRegeln;
        that.getVersicherungsbeginnRegeln = getVersicherungsbeginnRegeln;
        that.setVersicherungsbeginn = setVersicherungsbeginn;
        that.isKonditionVorhanden = isKonditionVorhanden;
        that.getKonditionen = getKonditionen;
        that.sortBausteine = sortBausteine;
        that.getVorversicherungen = getVorversicherungen;
        that.isVorversicherungValide = isVorversicherungValide;
        that.isBestandskunde = isBestandskunde;
        that.isUploadAvailable = isUploadAvailable;
        that.getStatusAntrag = getStatusAntrag;
        that.getNachrichtenAbschluss = getNachrichtenAbschluss;
        that.getErlaubteInkassoarten = getErlaubteInkassoarten;
        that.groupAntragVorbereiten = groupAntragVorbereiten;
        that.isKontaktErlaubtPartner = isKontaktErlaubtPartner;
        that.isKopierenErlaubt = isKopierenErlaubt;
        that.getAngebotsart = getAngebotsart;
        that.hasAngebotsart = hasAngebotsart;
        that.filterNachrichten = filterNachrichten;
        that.setSepaMandatErlaubt = setSepaMandatErlaubt;
        that.isSepaMandatErlaubt = isSepaMandatErlaubt;
        that.getTarifauskunftsdatumType = getTarifauskunftsdatumType;
        that.getTarifauskunftsdatumPath = getTarifauskunftsdatumPath;
        that.getTarifauskunftsdatum = getTarifauskunftsdatum;
        that.setTarifauskunftsdatum = setTarifauskunftsdatum;
        that.getDefaultTarifauskunftsdatum = getDefaultTarifauskunftsdatum;
        that.setBeitragsanpassungMessage = setBeitragsanpassungMessage;
        that.getBeitragsanpassungMessage = getBeitragsanpassungMessage;
        function resetServiceVariables(angebot) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            hinweismeldungDoppelversicherungAngezeigtHash = null;

            if (angular.isFunction(AngebotSpezifischService.resetServiceVariables)) {
                AngebotSpezifischService.resetServiceVariables(angebot);
            }
        }
        function _reset(properties, angebot, angebotInitial, ignoreProperties) {
            var angebotCopy = _.cloneDeep(angebotInitial);

            _.map(properties, function (prop) {
                _.map(ignoreProperties, function (ignoreProp) {
                    _.unset(_.get(angebotCopy, prop), ignoreProp);
                });

                if (_.isString(_.get(angebot, prop)) || _.get(angebotCopy, prop) === null) {
                    _.set(angebot, prop, _.get(angebotCopy, prop));
                } else {
                    _.assignIn(_.get(angebot, prop), _.get(angebotCopy, prop));
                }
            });
        }
        function initCustomAngebotService() {
            try {
                return $injector.get('FlexibleAngebotService');
            } catch (error) {
                return $injector.get('AngebotService');
            }
        }
        function getDIReference(name) {
            if ($injector.has(name)) {
                return $injector.get(name);
            } else {
                return {};
            }
        }
        function getAngebotSpezifischNamePrefix(angebot) {
            var angebotstyp = getAngebotstyp(angebot || AngebotModel.get().angebot);

            if (!angebotstyp) {
                return undefined;
            }

            return 'Angebot' + _.capitalize(angebotstyp);
        }
        function getConstant(name, angebot) {
            var AngebotSpezifischService,
                constant;

            if (angebot) {
                AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

                if (_.isFunction(AngebotSpezifischService.getConstant)) {
                    constant = AngebotSpezifischService.getConstant(name);
                }
            }

            return MiscUtilsService.isNotEmpty(constant) ? constant :_.get(CONSTANTS, name);
        }
        function getBausteineKeys(object, regExp) {
            return CustomAngebotService.getBausteineKeys(object, regExp);
        }
        function getGegenstaendeKeys(object, regExp) {
            return CustomAngebotService.getGegenstaendeKeys(object, regExp);
        }
        function getBausteine(obj, onlyActive, options) {
            return CustomAngebotService.getBausteine(obj, onlyActive, options);
        }
        function getGegenstaende(angebot, regExp, options) {
            return CustomAngebotService.getGegenstaende(angebot, regExp, options);
        }
        function getBeitraegeGroupedByProduktGruppe(angebot, options) {
            return CustomAngebotService.getBeitraegeGroupedByProduktGruppe(angebot, options);
        }
        function getPreparedBeitragsGegenstaende(angebot, options) {
            if (angular.isFunction(CustomAngebotService.getPreparedBeitragsGegenstaende)) {
                return CustomAngebotService.getPreparedBeitragsGegenstaende(angebot, options);
            }

            return null;
        }
        function getPreparedBeitragsBausteine(angebot, obj, options) {
            if (angular.isFunction(CustomAngebotService.getPreparedBeitragsBausteine)) {
                return CustomAngebotService.getPreparedBeitragsBausteine(angebot, obj, options);
            }

            return null;
        }
        function filterBeitraegeByProduktGruppe(beitraegeByProduktGruppe, produktGruppe, gegenstandId) {
            if (MiscUtilsService.isEmpty(beitraegeByProduktGruppe)) {
                return null;
            }

            return MiscUtilsService.isNotEmpty(gegenstandId) ? _.filter(beitraegeByProduktGruppe[produktGruppe], ['gegenstand.id', gegenstandId]) : beitraegeByProduktGruppe[produktGruppe];
        }
        function getTarifrechnerergebnisZeilen(obj) {
            return _.get(obj, 'ergebnisLetzteBerechnung.tarifrechnerergebnisZeilen', []);
        }
        function getStartStep(angebot, ignoreBeitraegeVorhanden, toStateParams) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (angular.isFunction(AngebotSpezifischService.getStartStep)) {
                return AngebotSpezifischService.getStartStep(angebot, ignoreBeitraegeVorhanden, toStateParams);
            }

            return !ignoreBeitraegeVorhanden && beitraegeVorhanden(angebot) ? 'rechner.ergebnis' : 'rechner.allgemein';
        }
        function getGlobals(angebotModel) {
            var AngebotUtilsService = $injector.get('AngebotUtilsService'),
                AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service'),
                globals = {};

            return $q(function (resolve, reject) {

                globals.maxAntragstellerGeburtsdatum = getMaxAntragstellerGeburtsdatum(angebotModel.angebot);
                globals.isAngebotAnonym = isAngebotAnonym(angebotModel.angebot);
                globals.isPrivatPerson = isPrivatPerson(angebotModel.angebot);
                globals.angebotstyp = getAngebotstyp(angebotModel.angebot);
                globals.antragstellerAenderbarMap = AngebotUtilsService.getAntragstellerDatenAenderbarMap(angebotModel.angebot);
                globals.ersatzgeschaeftAenderbarMap = AngebotUtilsService.getErsatzgeschaeftDatenAenderbarMap(angebotModel.angebot, angebotModel.angebotInitial);
                globals.isUploadEnabled = isUploadAvailable(angebotModel);
                globals.isTokenLoginSession = AuthenticationService.getSession().tokenLoginSession || IntegrationService.getIntegrationParams().isTokenLogin;
                if (AppConfig.ANGEBOT.plzAntragstellerEingabeImAngebot) {
                    globals.adressAuswahlFilterAntragsteller = {
                        postleitzahl: _.get(angebotModel.angebot, 'antragsteller.postleitzahl')
                    };
                }

                if (angular.isFunction(AngebotSpezifischService.getGlobals)) {
                    _.merge(globals, AngebotSpezifischService.getGlobals(angebotModel));
                }

                isPlzAntragstellerEingabeImAngebotVorhanden(angebotModel.angebot)
                    .then(function (plzAntragstellerEingabeImAngebotVorhanden) {
                        globals.plzAntragstellerEingabe = plzAntragstellerEingabeImAngebotVorhanden;

                        resolve(globals);
                    }).catch(function () {
                        globals.plzAntragstellerEingabe = false;

                        resolve(globals);
                    });
            });
        }
        function setDefaults(angebot) {
            var AngebotSpezifischModel = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Model');

            MiscUtilsService.setDefaultValueIfEmpty(angebot, 'antragsteller.mitgliedsart', SchluesselWerteUtilsService.create('MITGLIEDSART', '61'));
            MiscUtilsService.setDefaultValueIfEmpty(angebot, 'mandant', IdentityTypeUtilsService.create('MANDANTID', AppConfig.ANGEBOT.defaultMandant, AppConfig.ANGEBOT.defaultMandant));

            _.set(angebot, 'allgemeineAntragsdaten.dokumenteAusgehaendigt', false);
            _.set(angebot, 'allgemeineAntragsdaten.antragZusatzdokumenteBeratungsdokumentAusgehaendigt', false);
            _.set(angebot, 'allgemeineAntragsdaten.einverstaendnisBeginnVersicherungsschutzVorAblaufDerWiderruffrist', true);
            _.set(angebot, 'allgemeineAntragsdaten.verbraucherinformationAusgehaendigt', false);

            if (_.isFunction(AngebotSpezifischModel.setDefaults)) {
                AngebotSpezifischModel.setDefaults(angebot);
            }
        }
        function mapServiceData(angebot, angebotInitial) {
            var inkassoart = _.get(angebot, 'zahlungsinformationen.inkassoart'),
                erlaubteInkassoarten = getErlaubteInkassoarten(),
                kontoinhaber = _.get(angebot, 'zahlungsinformationen.kontoinhaber'),
                AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                AngebotPaymentService = $injector.has('AngebotPaymentService') && $injector.get('AngebotPaymentService'),
                AngebotUtilsService = $injector.get('AngebotUtilsService'),
                unterlagenErhalten = _.get(angebot, 'allgemeineAntragsdaten.unterlagenErhalten', false),
                antragsteller = getAngebotspartner(angebot, 'antragsteller');

            setTarifauskunftsdatum(angebot, getTarifauskunftsdatum(angebot));
            if (
                AppConfig.ANGEBOT.arbeitgeberBerufAbfrage === false &&
                isAngebotAenderbar(angebot, 'ANGEBOT') &&
                getAngebotstyp(angebot) !== 'KFZ' &&
                isPrivatPerson(angebot)
            ) {

                if (!AuthenticationService.isTokenLogin()) {
                    if (_.get(angebot, 'antragsteller.imOeffentlichemDienstTaetig')) {
                        MiscUtilsService.setDefaultValueIfEmpty(angebot, 'antragsteller.arbeitgeber', getConstant('arbeitgeber.oeffentlicherDienst'));
                    } else {
                        MiscUtilsService.setDefaultValueIfEmpty(angebot, 'antragsteller.arbeitgeber', getConstant('arbeitgeber.sonstigerArbeitgeber'));
                    }

                    MiscUtilsService.setDefaultValueIfEmpty(angebot, 'antragsteller.beruf', getConstant('beruf.ohneBerufsangabe'));
                } else {
                    MiscUtilsService.setDefaultValueIfEmpty(angebot, 'antragsteller.beruf', getConstant('beruf.ohneBerufsangabe'));
                }

                if (_.get(angebot, 'antragsteller.imOeffentlichemDienstTaetig') === false) {
                    MiscUtilsService.setDefaultValueIfEmpty(angebot, 'antragsteller.taetigkeitsschluessel', _.find(getConstant('taetigkeitsschluessel'), ['wert', '0']));
                }
            }

            if (!_.find(erlaubteInkassoarten, ['wert', inkassoart])) {
                _.set(angebot, 'zahlungsinformationen.inkassoart', getConstant('inkassoarten').abbucher.wert);
                inkassoart = getConstant('inkassoarten').abbucher.wert;
            }

            if ((kontoinhaber === getConstant('kontoinhaber').versicherungsnehmer.wert && !AngebotUtilsService.isAngebotAnonymisiert(angebot)) || (AngebotPaymentService && AngebotPaymentService.isAlternativeBezahlmethode(angebot))) {
                uebernehmeAntragstellerAlsPraemienzaher(angebot);
            }

            if (isAngebotAenderbar(angebot, 'ANTRAG')) {
                if (inkassoart === getConstant('inkassoarten').rechnung.wert) {
                    _.set(angebot, 'zahlungsinformationen.kontoinhaber', null);
                    loescheAngebotspartner(angebot, 'praemienzahler');
                } else if (inkassoart === getConstant('inkassoarten').abbucher.wert && kontoinhaber !== getConstant('kontoinhaber').anderePerson.wert) {
                    MiscUtilsService.setDefaultValueIfEmpty(angebot, 'zahlungsinformationen.sepaUnterschriftsart', SchluesselWerteUtilsService.create('UNTERSCHRIFTSART', 'E'));
                    if (isAngebotAenderbar(angebot, 'ANTRAG')) {
                        if (isPrivatPerson(angebot)) {
                            if (MiscUtilsService.isEverythingNotEmpty(antragsteller.vorname, antragsteller.nachname)) {
                                _.set(angebot, 'zahlungsinformationen.sepaUnterschrift', _.join([
                                    antragsteller.vorname,
                                    antragsteller.nachname
                                ], ' '));
                            }
                        } else if (MiscUtilsService.isEverythingNotEmpty(antragsteller.nachname)) {
                            _.set(angebot, 'zahlungsinformationen.sepaUnterschrift', _.trim(_.join(_.flatten([
                                antragsteller.nachname,
                                antragsteller.name2
                            ]), ' ')));
                        }
                        _.set(angebot, 'zahlungsinformationen.sepaOrt', antragsteller.ort);
                    }
                } else if (inkassoart === getConstant('inkassoarten').abbucher.wert && kontoinhaber === getConstant('kontoinhaber').anderePerson.wert) {
                    MiscUtilsService.setDefaultValueIfEmpty(angebot, 'zahlungsinformationen.praemienzahler.land', {
                        typ: 'LAND',
                        wert: 'D',
                        bezeichnung: 'Deutschland'
                    });
                } else if (AngebotPaymentService && AngebotPaymentService.isAlternativeBezahlmethode(angebot)) {
                    AngebotPaymentService.setResultsUrls(angebot);
                }
            }
            if (
                !AuthenticationService.hatBerechtigung('ANG_ABWEICHENDER_PRZ') &&
                kontoinhaber === getConstant('kontoinhaber').anderePerson.wert &&
                _.get(angebot, 'zahlungsinformationen.sepaUnterschriftsart.wert') !== 'P'
            ) {
                _.set(angebot, 'zahlungsinformationen.sepaUnterschriftsart', null);
            } else if (inkassoart === getConstant('inkassoarten').abbucher.wert && kontoinhaber !== getConstant('kontoinhaber').anderePerson.wert) {
                _.set(angebot, 'zahlungsinformationen.sepaUnterschriftsart', SchluesselWerteUtilsService.create('UNTERSCHRIFTSART', 'E'));
            }

            if (_.isFunction(AngebotSpezifischService.mapServiceData)) {
                AngebotSpezifischService.mapServiceData(angebot, angebotInitial);
            }
            if (angebot.uwgEinwilligung) {
                angebot.uwgEmail = _.get(getKommunikationsmedium(angebot, 'antragsteller', 'EMAILP'), 'wert');
            } else {
                angebot.uwgEmail = null;
            }

            if (isAngebotAenderbar(angebot, 'ANTRAG')) {
                _.set(angebot, 'allgemeineAntragsdaten.dokumenteAusgehaendigt', !!unterlagenErhalten);
                _.set(angebot, 'allgemeineAntragsdaten.antragZusatzdokumenteBeratungsdokumentAusgehaendigt', !!unterlagenErhalten);
            }

            if (_.get(angebot, 'partnerIcis.geburtsdatum') && !_.get(angebot, 'antragsteller.geburtsdatum')) {
                _.set(angebot, 'antragsteller.geburtsdatum', _.get(angebot, 'partnerIcis.geburtsdatum'));
            }
        }
        function mapFormToServiceData(formData, angebot, angebotInitial, ignoreMapServiceData) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                komeNullValueObjects = {};

            ['EMAILP', 'TELP', 'TELM', 'EMAILG', 'TELG'].forEach(function (komeArt) {
                komeNullValueObjects[komeArt] = ObjectTypeUtilsService.create('kommunikationsmedium', {
                    kommunikationswegId: null,
                    wert: '',
                    art: komeArt
                });
            });

            setKommunikationsmedium(angebot, 'antragsteller', _.get(formData, 'antragsteller.emailPrivat', komeNullValueObjects.EMAILP));
            setKommunikationsmedium(angebot, 'antragsteller', _.get(formData, 'antragsteller.telefonPrivat', komeNullValueObjects.TELP));
            setKommunikationsmedium(angebot, 'antragsteller', _.get(formData, 'antragsteller.telefonMobil', komeNullValueObjects.TELM));
            setKommunikationsmedium(angebot, 'antragsteller', _.get(formData, 'antragsteller.emailGeschaeftlich', komeNullValueObjects.EMAILG));
            setKommunikationsmedium(angebot, 'antragsteller', _.get(formData, 'antragsteller.telefonGeschaeftlich', komeNullValueObjects.TELG));
            if (isAngebotAenderbar(angebot, 'ANTRAG')) {
                if (
                    AppConfig.ANGEBOT.abschlussType !== 'ANTRAG_DRUCKEN' &&
                    ((
                        MiscUtilsService.isNotEmpty(_.get(formData, 'antragsteller.emailPrivat.wert')) &&
                        isPrivatPerson(angebot)
                    ) || (
                        MiscUtilsService.isNotEmpty(_.get(formData, 'antragsteller.emailGeschaeftlich.wert')) &&
                        !isPrivatPerson(angebot)
                    ))
                ) {
                    if (isPrivatPerson(angebot)) {
                        _.set(angebot, 'empfangsBestaetigungEmailAdresse', _.get(formData, 'antragsteller.emailPrivat.wert'));
                    } else {
                        _.set(angebot, 'empfangsBestaetigungEmailAdresse', _.get(formData, 'antragsteller.emailGeschaeftlich.wert'));
                    }
                    _.set(angebot, 'empfangsBestaetigungEmailSenden', true);
                } else {
                    _.set(angebot, 'empfangsBestaetigungEmailAdresse', null);
                    _.set(angebot, 'empfangsBestaetigungEmailSenden', null);
                }
            }
            _.set(angebot, 'uwgEinwilligung', _.get(formData, 'antragsteller.kontaktErlaubt', null));

            if (_.isFunction(AngebotSpezifischService.mapFormToServiceData)) {
                AngebotSpezifischService.mapFormToServiceData(formData, angebot, angebotInitial);
            }

            if (MiscUtilsService.isNotEmpty(AppConfig.ANGEBOT.mockAngebotstyp)) {
                angebot.angebotstyp = AppConfig.ANGEBOT.mockAngebotstyp;
            }

            if (!ignoreMapServiceData) {
                mapServiceData(angebot, angebotInitial);
            }
        }
        function mapServiceToFormData(angebot, formData, angebotInitial) {
            if (MiscUtilsService.isNotEmpty(AppConfig.ANGEBOT.mockAngebotstyp)) {
                angebot.angebotstyp = AppConfig.ANGEBOT.angebotstyp;
            }

            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                AngebotPaymentService = $injector.has('AngebotPaymentService') && $injector.get('AngebotPaymentService'),
                AngebotUtilsService = $injector.get('AngebotUtilsService'),
                angebotModel = AngebotModel.get();
            if (angebotModel.wurdeGeladen) {
                _.set(formData, 'blaulichtVorhanden', MiscUtilsService.isNotEmpty(_.get(angebot, 'antragsteller.blaulicht.wert')));
            } else {
                _.set(formData, 'blaulichtVorhanden', MiscUtilsService.isNotEmpty(_.get(angebot, 'antragsteller.blaulicht.wert')) ? true : !!_.get(formData, 'blaulichtVorhanden'));
            }

            _.set(formData, 'antragsteller.emailPrivat', getKommunikationsmedium(angebot, 'antragsteller', 'EMAILP'));
            _.set(formData, 'antragsteller.telefonPrivat', getKommunikationsmedium(angebot, 'antragsteller', 'TELP'));
            _.set(formData, 'antragsteller.telefonMobil', getKommunikationsmedium(angebot, 'antragsteller', 'TELM'));
            _.set(formData, 'antragsteller.emailGeschaeftlich', getKommunikationsmedium(angebot, 'antragsteller', 'EMAILG'));
            _.set(formData, 'antragsteller.telefonGeschaeftlich', getKommunikationsmedium(angebot, 'antragsteller', 'TELG'));
            _.set(formData, 'antragsteller.privatkunde', isPrivatPerson(angebot));

            if (_.isFunction(AngebotSpezifischService.mapServiceToFormData)) {
                AngebotSpezifischService.mapServiceToFormData(angebot, formData, angebotInitial);
            }

            if (AngebotPaymentService && AngebotPaymentService.isAlternativeBezahlmethode(angebot)) {
                if (MiscUtilsService.isNotEmpty(_.get(angebot, 'zahlungsinformationen.bezahldienstleisterDaten.accountNumber'))) {
                    _.set(formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.accountNumber', _.get(angebot, 'zahlungsinformationen.bezahldienstleisterDaten.accountNumber'));
                }
            }

            _.set(formData, 'zahlungsinformationen.abweichenderPraemienzahler', _.get(angebot, 'zahlungsinformationen.kontoinhaber') === getConstant('kontoinhaber').anderePerson.wert);
            _.set(formData, 'antragsteller.kontaktErlaubt', _.get(angebot, 'uwgEinwilligung'));
            _.set(formData, 'allgemeineAntragsdaten.emailPrivatAnonymisiert', AngebotUtilsService.isWertAnonymisiert(getKommunikationsmedium(angebot, 'antragsteller', 'EMAILP'), 'EMAIL'));
            _.set(formData, 'allgemeineAntragsdaten.ibanAnonymisiert', AngebotUtilsService.isWertAnonymisiert(_.get(angebot, 'zahlungsinformationen.praemienzahler.iban'), 'IBAN'));
            _.set(formData, 'allgemeineAntragsdaten.antragstellerAdressePrivatAnonymisiert', AngebotUtilsService.isWertAnonymisiert(_.get(angebot, 'antragsteller.postleitzahl'), 'PLZ'));
            _.set(angebot, 'zahlungsinformationen.praemienzahler.bankname', _.get(angebotModel.angebot, 'zahlungsinformationen.praemienzahler.bankname'));
            _.set(angebot, 'zahlungsinformationen.praemienzahler.bankort', _.get(angebotModel.angebot, 'zahlungsinformationen.praemienzahler.bankort'));
        }
        function getTaetigkeitsschluessel(arbeitgeberCode, berufCode) {
            return $http({
                method: 'GET',
                url: AppConfig.API.services.angTaetigkeitsschluessel,
                params: {
                    arbeitgeber: arbeitgeberCode,
                    beruf: berufCode
                },
                cache: true,
                globalErrorsIgnore: {
                    errors: true
                }
            }).then(function (response) {
                return response.data;
            }).catch(function (error) {
                return getConstant('taetigkeitsschluessel');
            });
        }
        function berechne(angebotModel, config) {
            var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                httpConfig;

            mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);

            if (!isAngebotAenderbar(angebotModel.angebot, 'ANTRAG')) {
                return $q.reject('ANGEBOT_NICHT_AENDERBAR');
            }

            config.params = config.params || {};

            if (config.params.angebotSpeichern) {
                that.speichereServiceInProgress.push(true);
            }

            that.berechneServiceInProgress.push(true);

            httpConfig = {
                method: 'POST',
                url: FormatUtilsService.replace(AppConfig.API.services.angBerechnen, angebotModel.tarif.tarifkuerzel),
                data: angebotModel.angebot
            };

            _.merge(httpConfig, config);

            return $http(httpConfig).then(function (response) {
                mapServiceToFormData(response.data.angebot, angebotModel.formData, angebotModel.angebotInitial);

                that.forceBerechnen = false;

                angebotModel.angebot = angular.merge({}, response.data.angebot);
                angebotModel.angebotLetzteBerechnung = _.cloneDeep(angebotModel.angebot);
                angebotModel.angebotLetzterRefresh = _.cloneDeep(angebotModel.angebot);

                $log.debug('BasisAngebotService.berechne THEN', 'response Angebot', response.data.angebot, 'angebot nach Merge', angebotModel.angebot);

                if (config.params.angebotSpeichern) {
                    angebotModel.angebotLetzteSpeicherung = _.cloneDeep(angebotModel.angebot);

                    if (!angebotsnummer) {
                        IntegrationService.sendMessage({
                            type: 'asysAction',
                            data: {
                                type: 'ANGEBOT_ANGELEGT',
                                context: {
                                    id: getAngebotsnummer(angebotModel.angebot),
                                    type: 'ANGEBOTSNUMMER'
                                }
                            }
                        });
                    }
                }

                if (config.params.angebotSpeichern) {
                    that.speichereServiceInProgress.splice(-1, 1);
                }
                that.berechneServiceInProgress.splice(-1, 1);

                return {
                    angebot: response.data.angebot,
                    nachrichten: response.data.nachrichten
                };
            }).catch(function (error) {
                mapServiceToFormData(angebotModel.angebot, angebotModel.formData, angebotModel.angebotInitial);

                angebotModel.angebotLetzteBerechnung = null;

                if (MiscUtilsService.isNotEmpty(_.get(error, 'data.angebot'))) {
                    angebotModel.angebot = angular.merge({}, error.data.angebot);

                    if (config.params.angebotSpeichern) {
                        angebotModel.angebotLetzteSpeicherung = _.cloneDeep(angebotModel.angebot);
                    }
                } else {

                    if (config.params.angebotSpeichern) {
                        angebotModel.angebotLetzteSpeicherung = null;
                    }
                }

                if (config.params.angebotSpeichern) {
                    that.speichereServiceInProgress.splice(-1, 1);
                }
                that.berechneServiceInProgress.splice(-1, 1);

                $log.debug('BasisAngebotService.berechne CATCH', 'response Angebot', _.get(error, 'data.angebot'), 'angebot nach Merge', angebotModel.angebot);

                return $q.reject(error);
            });
        }
        function refresh(angebotModel, options) {
            var params = {
                pathParameters: {},
                queryParameters: {}
            };

            options = options || {};

            if (angebotModel && angebotModel.isDummyModel) {
                params.pathParameters.gevo = _.get(angebotModel.angebot, 'gevoId');

                return AngebotModel.erstelleNeuesAngebot(getTarifauskunftsdatum(angebotModel.angebot), angebotModel.tarif.tarifkuerzel, params).then(function (data) {
                    angebotModel.isDummyModel = false;
                    return data.angebot;
                });
            } else {
                return $http({
                    method: 'POST',
                    url: FormatUtilsService.replace(AppConfig.API.services.angRefresh, angebotModel.tarif.tarifkuerzel),
                    params: {
                        updateVerDaten: !!options.shouldRefreshVertragsdaten
                    },
                    data: angebotModel.angebot
                }).then(function (response) {
                    return response.data;
                });
            }
        }
        function refreshAngebot(angebotModel, options) {
            return $q(function (resolve, reject) {
                var geaendert = false;

                options = options || {};

                mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);

                geaendert = hatAenderungen(angebotModel.angebot, angebotModel.angebotLetzterRefresh);
                angebotModel.angebotLetzterRefresh = _.cloneDeep(angebotModel.angebot);

                if (!geaendert && !options.shouldRefreshVertragsdaten) {
                    $log.debug('BasisAngebotService.refreshAngebot CACHE');
                    return resolve(angebotModel.angebot);
                }

                return refresh(angebotModel, options).then(function (refreshedAngebot) {
                    refreshZasZapUndSbLg(angebotModel.angebot, refreshedAngebot);

                    mapServiceToFormData(refreshedAngebot, angebotModel.formData, angebotModel.angebotInitial);

                    angebotModel.angebot = angular.merge({}, refreshedAngebot);

                    resolve(refreshedAngebot);
                }).catch(function (error) {
                    angebotModel.angebotLetzterRefresh = null;
                    reject(error);
                });
            });
        }
        function refreshMandatUndTarifgruppe(angebotModel) {
            return $q(function (resolve, reject) {
                var geaendert = false;

                mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);

                geaendert = hatAenderungenFuerTarifgruppe(angebotModel.angebot, angebotModel.angebotLetzterRefresh);
                angebotModel.angebotLetzterRefresh = _.cloneDeep(angebotModel.angebot);

                if (!geaendert) {
                    $log.debug('BasisAngebotService.refreshMandatUndTarifgruppe CACHE');
                    return resolve(angebotModel.angebot);
                }

                return refresh(angebotModel).then(function (refreshedAngebot) {
                    _.set(angebotModel.angebot, 'antragsteller.tarifgruppe', _.get(refreshedAngebot, 'antragsteller.tarifgruppe'));
                    _.set(angebotModel.angebot, 'mandant', _.get(refreshedAngebot, 'mandant'));

                    refreshZasZapUndSbLg(angebotModel.angebot, refreshedAngebot);

                    resolve(angebotModel.angebot);
                }).catch(function (error) {
                    angebotModel.angebotLetzterRefresh = null;
                    reject(error);
                });
            });
        }
        function refreshZasZapUndSbLg(angebot, refreshedAngebot) {
            _.each(getBausteineKeys(angebot), function (bausteinKey) {
                _.set(angebot, bausteinKey + '.zasZapAnfrageErgebnis', _.get(refreshedAngebot, bausteinKey + '.zasZapAnfrageErgebnis'));
                MiscUtilsService.setDefaultValueIfEmpty(angebot, bausteinKey + '.leistungsgrenze', _.get(refreshedAngebot, bausteinKey + '.leistungsgrenze'));
                MiscUtilsService.setDefaultValueIfEmpty(angebot, bausteinKey + '.selbstbeteiligung', _.get(refreshedAngebot, bausteinKey + '.selbstbeteiligung'));
            });
        }
        function beitragsanpassung(angebotModel, aktion) {
            if (MiscUtilsService.isAtLeastOneEmpty(AppConfig.API.services.angBeitragsanpassung, aktion)) {
                return $q.resolve({
                    angebot: angebotModel.angebot,
                    nachrichten: []
                });
            }

            mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);

            return $http({
                method: 'POST',
                url: FormatUtilsService.replace(AppConfig.API.services.angBeitragsanpassung, angebotModel.tarif.tarifkuerzel, aktion),
                data: angebotModel.angebot
            }).then(function (response) {
                mapServiceToFormData(response.data.angebot, angebotModel.formData, angebotModel.angebotInitial);

                return response.data;
            });
        }
        function speichere(angebotModel, options) {
            options = options || {};

            return $q(function (resolve, reject) {
                var serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angSpeichern, angebotModel.tarif.tarifkuerzel),
                    angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                    cacheId = serviceUrl + angebotsnummer,
                    geaendert = true,
                    result;

                mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);

                if (!isAngebotAenderbar(angebotModel.angebot, 'ANTRAG')) {
                    return reject('ANGEBOT_NICHT_AENDERBAR');
                }

                geaendert = hatAenderungen(angebotModel.angebot, angebotModel.angebotLetzteSpeicherung);

                if (ApiCacheService.isCached(cacheId) && !geaendert) {
                    result = ApiCacheService.get(cacheId);

                    angebotModel.angebotLetzteSpeicherung = _.cloneDeep(angebotModel.angebot);
                    result.angebot = angebotModel.angebot;

                    $log.debug('BasisAngebotService.speichere CACHE');
                    return resolve(result);
                }
                that.speichereServiceInProgress.push(true);

                return $http({
                    method: 'POST',
                    url: serviceUrl,
                    data: angebotModel.angebot,
                    globalErrorsIgnore: options.globalErrorsIgnore,
                    httpErrorsIgnore: options.httpErrorsIgnore
                }).then(function (response) {
                    mapServiceToFormData(response.data.angebot, angebotModel.formData, angebotModel.angebotInitial);

                    if (!angebotsnummer) {
                        IntegrationService.sendMessage({
                            type: 'asysAction',
                            data: {
                                type: 'ANGEBOT_ANGELEGT',
                                context: {
                                    id: getAngebotsnummer(response.data.angebot),
                                    type: 'ANGEBOTSNUMMER'
                                }
                            }
                        });
                    }

                    angebotModel.angebotLetzteSpeicherung = _.cloneDeep(response.data.angebot);

                    result = {
                        angebot: response.data.angebot,
                        nachrichten: response.data.nachrichten
                    };

                    ApiCacheService.put(cacheId, result);
                    that.speichereServiceInProgress.splice(-1, 1);

                    return resolve(result);
                }).catch(function (error) {
                    angebotModel.angebotLetzteSpeicherung = null;
                    ApiCacheService.remove(cacheId);
                    that.speichereServiceInProgress.splice(-1, 1);

                    return reject(error);
                });
            });
        }
        function loesche(angebotModel, options) {
            options = options || {};

            return $q(function (resolve, reject) {
                var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                    angebotsToken = getToken(angebotModel.angebot),
                    serviceUrl = AppConfig.API.services.angLoeschen,
                    tarifkuerzel = _.get(angebotModel, 'tarif.tarifkuerzel');

                if (!isAngebotAenderbar(angebotModel.angebot, 'ANTRAG')) {
                    return reject('ANTRAG_NICHT_AENDERBAR');
                }

                if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, tarifkuerzel, serviceUrl)) {
                    return reject('NICHT_ALLE_DATEN_VORHANDEN');
                }

                serviceUrl = FormatUtilsService.replace(serviceUrl, tarifkuerzel, angebotsnummer, angebotsToken);

                return $http({
                    method: 'DELETE',
                    url: serviceUrl,
                    globalErrorsIgnore: options.globalErrorsIgnore
                }).then(function (response) {
                    return resolve();
                }).catch(function (error) {
                    return reject(error);
                });
            });
        }
        function erzeugeVertrag(angebotModel) {
            var AngebotUtilsService = $injector.get('AngebotUtilsService'),
                AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service');

            mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);

            if (!isAngebotAenderbar(angebotModel.angebot, 'ANTRAG')) {
                return $q.reject('ANGEBOT_NICHT_AENDERBAR');
            }

            if (AngebotSpezifischService.pruefeErzeugeVertrag) {
                if (AngebotSpezifischService.pruefeErzeugeVertrag(angebotModel.angebot, true) === false) {
                    return $q.reject('ANTRAG_NICHT_ZULAESSIG');
                }
            }

            TrackingUtilsService.trackVertragsabschluss(angebotModel);

            return $http({
                method: 'POST',
                url: FormatUtilsService.replace(AppConfig.API.services.angErzeugeVertrag, angebotModel.tarifkuerzel),
                data: angebotModel.angebot,
                timeout: AppConfig.API.timeoutLong
            }).then(function (response) {
                var context = {};
                mapServiceToFormData(response.data.angebot, angebotModel.formData, angebotModel.angebotInitial);

                context = {
                    id: getAngebotsnummer(response.data.angebot),
                    type: 'ANGEBOTSNUMMER'
                };
                _.forEach(_.get(response.data, 'nachrichten'), function (nachricht) {
                    if (_.size(AngebotUtilsService.getVertragsnummerFromApiNachricht(nachricht.meldung)) > 0) {
                        context = {
                            id: AngebotUtilsService.getVertragsnummerFromApiNachricht(nachricht.meldung, true),
                            type: 'VERTRAGSNUMMER'
                        };
                        return false;
                    }
                });

                IntegrationService.sendMessage({
                    type: 'asysAction',
                    data: {
                        type: _.includes([
                            AppConfig.ANGEBOT.status.VERTRAGSAENDERUNG,
                            AppConfig.ANGEBOT.status.VERTRAGSANLAGE
                        ], getStatus(response.data.angebot)) ? 'VERTRAG_AKTUALISIERT' : 'ANGEBOT_AKTUALISIERT',
                        context: context
                    }
                });

                return response.data;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function antragDrucken(angebotModel, druckweg) {
            druckweg = druckweg || getConstant('druckwege').vorschau.wert;

            var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                angebotsToken = getToken(angebotModel.angebot),
                serviceUrl,
                tarifkuerzel = _.get(angebotModel, 'tarif.tarifkuerzel'),
                responseType = '',
                isStream = druckweg === _.get(getConstant('druckwege'), 'vorschau.wert'),
                timeout;

            serviceUrl = AppConfig.API.services['angAntragDruck' + _.capitalize(druckweg)];

            if (MiscUtilsService.isAtLeastOneEmpty(tarifkuerzel, angebotsnummer, angebotsToken, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            serviceUrl = FormatUtilsService.replace(serviceUrl, tarifkuerzel, angebotsnummer, angebotsToken);

            if (isStream) {
                timeout = AppConfig.API.timeoutLong;
                responseType = 'arraybuffer';
            }

            $analytics.eventTrack('download', {
                target: 'Antrag',
                tags: _.capitalize(druckweg)
            });

            return $http({
                method: 'GET',
                url: serviceUrl,
                responseType: responseType,
                timeout: timeout,
                globalErrorsIgnore: {
                    errors: true
                }
            }).then(function (response) {
                var data = response.data,
                    fileInfos;
                IntegrationService.sendMessage({
                    type: 'asysAction',
                    data: {
                        type: 'ANTRAG_GEDRUCKT',
                        context: {
                            id: angebotsnummer,
                            type: 'ANGEBOTSNUMMER'
                        }
                    }
                });

                if (isStream) {
                    fileInfos = ApiService.getFileinfosFromHeader(response.headers()['filename-upload']);

                    data = {
                        binary: data,
                        filename: fileInfos.filename,
                        mimeType: BinaryUtilsService.getMimeType(fileInfos.extension)
                    };
                }

                return data;

            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function antragUebersichtDrucken(angebotModel) {
            var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                angebotsToken = getToken(angebotModel.angebot),
                serviceUrl = AppConfig.API.services.angAntragUebersichtDrucken,
                responseType = 'arraybuffer',
                timeout = AppConfig.API.timeoutLong;

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            serviceUrl = FormatUtilsService.replace(serviceUrl, angebotsnummer, angebotsToken);

            $analytics.eventTrack('download', {
                target: 'Antragsübersicht',
                tags: 'Vorschau'
            });

            return $http({
                method: 'GET',
                url: serviceUrl,
                responseType: responseType,
                timeout: timeout,
                globalErrorsIgnore: {
                    errors: true
                }
            }).then(function (response) {
                var data = response.data,
                    fileInfos;

                fileInfos = ApiService.getFileinfosFromHeader(response.headers()['filename-upload']);

                return {
                    binary: data,
                    filename: fileInfos.filename,
                    mimeType: BinaryUtilsService.getMimeType(fileInfos.extension)
                };
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function validiere(data) {
            var versicherungsbeginnAnpassungNotwendigMessage,
                versicherungsbeginnKopieNotwendigMessage;

            mapFormToServiceData(data.formData, data.angebot);

            return $http({
                method: 'POST',
                url: FormatUtilsService.replace(AppConfig.API.services.angValidiere, data.tarifkuerzel, data.stufe),
                data: data.angebot,
                globalErrorsIgnore: {
                    errors: {
                        reason: [
                            'VERSICHERUNGSBEGINN_ANPASSUNG_NOTWENDIG',
                            'VERSICHERUNGSBEGINN_KOPIE_NOTWENDIG'
                        ]
                    }
                }
            }).then(function (response) {
                mapServiceToFormData(data.angebot, data.formData, data.angebotInitial);

                return response.data;
            }).catch(function (response) {
                versicherungsbeginnAnpassungNotwendigMessage = _.find(response.data, ['reason', 'VERSICHERUNGSBEGINN_ANPASSUNG_NOTWENDIG']);
                versicherungsbeginnKopieNotwendigMessage = _.find(response.data, ['reason', 'VERSICHERUNGSBEGINN_KOPIE_NOTWENDIG']);

                if (versicherungsbeginnAnpassungNotwendigMessage) {
                    versicherungsbeginnAnpassungNotwendigMessage.message += ' ' + AppConfig.MESSAGES.hinweisVersicherungsbeginnAnpassungNotwendig;
                    versicherungsbeginnAnpassungNotwendigMessage.cause = 'VALIDATION_INFO';

                    $rootScope.$emit('iplusjs:addAlert', ApiService.getApiExceptionsAsAlerts([versicherungsbeginnAnpassungNotwendigMessage]));
                }

                if (versicherungsbeginnKopieNotwendigMessage) {
                    if (_.get(data.angebot, 'kopierenBlockiert') === true) {
                        versicherungsbeginnKopieNotwendigMessage.message += ' ' + AppConfig.MESSAGES.hinweisVersicherungsbeginnNeuesAngebotNotwendig;
                        versicherungsbeginnKopieNotwendigMessage.cause = 'VALIDATION_INFO';
                    } else {
                        versicherungsbeginnKopieNotwendigMessage.message += ' ' + AppConfig.MESSAGES.hinweisVersicherungsbeginnKopieNotwendig;
                        versicherungsbeginnKopieNotwendigMessage.cause = 'VALIDATION_INFO';
                    }

                    $rootScope.$emit('iplusjs:addAlert', ApiService.getApiExceptionsAsAlerts([versicherungsbeginnKopieNotwendigMessage]));
                }

                return $q.reject(response);
            });
        }
        function getEKomiLink(angebot) {
            var angebotsnummer = getAngebotsnummer(angebot),
                angebotsToken = getToken(angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angEKomi, angebotsnummer, angebotsToken);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http.get(serviceUrl, {
                cache: true,
                globalErrorsIgnore: {
                    errors: true
                },
                unexpectedErrorsIgnore: true
            }).then(function (response) {
                return response.data;
            });
        }
        function prepareAddDateiAnhaenge(angebot, files) {
            var promises = [],
                angebotsnummer = getAngebotsnummer(angebot),
                angebotsToken = getToken(angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angDateiAnhangMultipart, angebotsnummer, angebotsToken);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, serviceUrl)) {
                return 'NICHT_ALLE_DATEN_VORHANDEN';
            }

            if (!modernizr.xhr2) {
                return 'NICHT_UNTERSTÜTZT';
            }

            _.forEach(files, function (file) {
                var formData = new $window.FormData();
                formData.append('file', file);
                formData.append('filename', file.name);
                formData.append('mimeType', file.type);

                promises.push(function () {
                    $analytics.eventTrack('link', {
                        target: 'Upload-Datei'
                    });

                    return $http.post(serviceUrl, formData, {
                        transformRequest: angular.identity,
                        file: file,
                        timeout: AppConfig.API.timeoutLong,
                        headers: {
                            'Content-Type': undefined
                        },
                        globalErrorsIgnore: {
                            errors: true
                        },
                        httpErrorsIgnore: [403]
                    });
                });
            });

            return promises;
        }
        function getDateiAnhang(angebot, anhangId) {
            var angebotsnummer = getAngebotsnummer(angebot),
                angebotsToken = getToken(angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angGetDateiAnhang, angebotsnummer, angebotsToken, anhangId);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, anhangId, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http.get(serviceUrl, {
                cache: true,
                responseType: 'arraybuffer'
            }).then(function (response) {
                var fileInfos = ApiService.getFileinfosFromHeader(response.headers()['content-disposition'], 'content-disposition');

                return {
                    binary: response.data,
                    filename: fileInfos.filename,
                    mimeType: BinaryUtilsService.getMimeType(fileInfos.extension)
                };
            });
        }
        function deleteDateiAnhang(angebot, anhangId) {
            var angebotsnummer = getAngebotsnummer(angebot),
                angebotsToken = getToken(angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angDeleteDateiAnhang, angebotsnummer, angebotsToken, anhangId);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, anhangId, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            $analytics.eventTrack('link', {
                target: 'Delete-Datei'
            });

            return $http.delete(serviceUrl)
                .then(function (response) {
                    removeDateiAnhang(angebot, anhangId);

                    return response.data;
                });
        }
        function angebotDrucken(angebotModel, druckweg) {
            var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                angebotsToken = getToken(angebotModel.angebot),
                serviceUrl = AppConfig.API.services['angAngebotDruck' + _.capitalize(druckweg)],
                responseType = '',
                geaendert = false,
                result,
                cacheId,
                isStream = druckweg === _.get(getConstant('druckwege'), 'vorschau.wert'),
                timeout,
                geschaeftlParam;

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, druckweg, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            if (!isAngebotAenderbar(angebotModel.angebot, 'ANTRAG')) {
                return $q.reject('ANGEBOT_NICHT_AENDERBAR');
            }

            serviceUrl = FormatUtilsService.replace(serviceUrl, angebotsnummer, angebotsToken);
            cacheId = serviceUrl;
            if (AppConfig.ANGEBOT.privatkundeEingabeImAngebot === false) {
                geschaeftlParam = false;
            } else {
                geschaeftlParam = isPrivatPerson(angebotModel.angebot) ? false : true;
            }

            geaendert = hatAenderungen(angebotModel.angebot, angebotModel.angebotLetzterDruck);

            if (ApiCacheService.isCached(cacheId) && !geaendert) {
                result = ApiCacheService.get(cacheId);

                $log.debug('BasisAngebotService.angebotDrucken CACHE');
                return $q.resolve(result);
            }

            if (isStream) {
                timeout = AppConfig.API.timeoutLong;
                responseType = 'arraybuffer';
            }

            $analytics.eventTrack('download', {
                target: 'Tarifauskunft-' + _.capitalize(druckweg),
                tags: _.capitalize(druckweg)
            });

            return $http({
                method: 'GET',
                url: serviceUrl,
                responseType: responseType,
                timeout: timeout,
                params: {
                    geschaeftl: geschaeftlParam
                }
            }).then(function (response) {
                var data = response.data,
                    fileInfos;
                IntegrationService.sendMessage({
                    type: 'asysAction',
                    data: {
                        type: 'ANGEBOT_GEDRUCKT',
                        context: {
                            id: angebotsnummer,
                            type: 'ANGEBOTSNUMMER'
                        }
                    }
                });
                setStatusNachDruck(angebotModel.angebot);
                angebotModel.angebotLetzterDruck = _.cloneDeep(angebotModel.angebot);

                if (isStream) {
                    fileInfos = ApiService.getFileinfosFromHeader(response.headers()['filename-upload']);

                    data = {
                        binary: data,
                        filename: fileInfos.filename,
                        mimeType: BinaryUtilsService.getMimeType(fileInfos.extension)
                    };
                }

                ApiCacheService.put(cacheId, data);

                return data;

            }).catch(function (error) {
                if (MiscUtilsService.isEmpty(ApiService.getApiNachrichtenFromResponse(error, 'FEHLER'))) {
                    setStatusNachDruck(angebotModel.angebot);
                }

                angebotModel.angebotLetzterDruck = null;
                ApiCacheService.remove(cacheId);

                return $q.reject(error);
            });
        }
        function checkAvbChanged(angebot) {
            var angebotsnummer = getAngebotsnummer(angebot),
                angebotsToken = getToken(angebot),
                stichtag = getTarifauskunftsdatum(angebot),
                serviceUrl = AppConfig.API.services.angAvb,
                avbVersion;

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, serviceUrl)) {
                return $q.resolve(false);
            }

            if (MiscUtilsService.isAtLeastOneEmpty(stichtag)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angAvb, angebotsnummer, angebotsToken);

            return $http.get(serviceUrl, {
                cache: true,
                params: {
                    stichtag: stichtag
                }
            }).then(function (response) {
                var avbChanged = false;

                _.forEach(response.data, function (avbProdukt) {
                    avbVersion = getAvbVersion(angebot, _.get(avbProdukt, 'produkt.wert'));
                    if (!_.isNil(avbVersion) && avbVersion !== parseInt(_.get(avbProdukt, 'avb'))) {
                        avbChanged = true;
                        return false;
                    }
                });

                return $q.resolve(avbChanged);
            }).catch(function (error) {
                return $q.resolve(false);
            });
        }
        function checkSepaMandatAktiv(angebot) {
            var AngebotUtilsService = $injector.get('AngebotUtilsService'),
                AngebotPaymentService = $injector.has('AngebotPaymentService') && $injector.get('AngebotPaymentService'),
                zahlungsinformationen = _.get(angebot, 'zahlungsinformationen', {}),
                praemienzahler = getAngebotspartner(angebot, 'praemienzahler'),
                angebotsnummer = getAngebotsnummer(angebot),
                angebotsToken = getToken(angebot),
                iban = IdentityTypeUtilsService.getId(praemienzahler.iban),
                serviceUrl;
            if (
                zahlungsinformationen.inkassoart !== getConstant('inkassoarten').abbucher.wert ||
                AngebotPaymentService && AngebotPaymentService.isAlternativeBezahlmethode(angebot)
            ) {
                return $q.resolve(false);
            }

            if (MiscUtilsService.isAtLeastOneEmpty(praemienzahler, praemienzahler.iban)) {
                return $q.resolve(false);
            }
            if (AngebotUtilsService.isWertAnonymisiert(iban, 'IBAN') && _.get(angebot, 'zahlungsinformationen.sepaAktiv')) {
                return $q.resolve(true);
            }
            if (zahlungsinformationen.kontoinhaber === getConstant('kontoinhaber').anderePerson.wert) {
                return $q.resolve(true);
            }
            if (MiscUtilsService.isEmpty(praemienzahler.partnernummer)) {
                return $q.resolve(false);
            }

            serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angSepaMandat, angebotsnummer, angebotsToken, iban);

            return $http.get(serviceUrl, {
                cache: true
            }).then(function (response) {
                return response.data;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function isPrivatPerson(angebot, angebotspartner) {
            var mitgliedsart;

            if (_.isObject(angebotspartner)) {
                mitgliedsart = _.get(angebotspartner, 'mitgliedsart');
            } else {
                mitgliedsart = getAngebotspartner(angebot, angebotspartner || 'antragsteller').mitgliedsart;
            }
            return _.includes(AppConfig.ANGEBOT.mgaPrivat, _.get(mitgliedsart, 'wert', '61'));
        }
        function getAngebotstyp(angebot) {
            return _.get(angebot, 'angebotstyp');
        }
        function getAngebotsnummer(angebot, formatiert) {
            return _.get(angebot, formatiert ? 'angebotsnummer.formatiert' : 'angebotsnummer.id');
        }
        function getProduktGruppen() {
            return CustomAngebotService.getProduktGruppen.apply(null, arguments);
        }
        function getStatus(angebot) {
            return _.get(angebot, 'status', AppConfig.ANGEBOT.status.ANGEBOT);
        }
        function setStatus(angebot, status) {
            if (!_.includes(AppConfig.ANGEBOT.status, status)) {
                return;
            }

            _.set(angebot, 'status', status);
        }

        function setStatusNachDruck(angebot) {
            var status = AppConfig.ANGEBOT.statusNachDruck;

            setStatus(angebot, status);
        }
        function isAngebotAenderbar(angebot, type) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            type = type || 'ANGEBOT';

            if (angular.isFunction(AngebotSpezifischService.isAngebotAenderbar)) {
                return AngebotSpezifischService.isAngebotAenderbar(angebot, type);
            }

            if (type === 'ANGEBOT') {
                return _.includes([AppConfig.ANGEBOT.status.ANGEBOT], getStatus(angebot));
            } else if (type === 'ANTRAG') {
                return _.includes([AppConfig.ANGEBOT.status.ANGEBOT, AppConfig.ANGEBOT.status.GEDRUCKT, AppConfig.ANGEBOT.status.GEDRUCKT_TEILWEISE_AENDERBAR, AppConfig.ANGEBOT.status.ANTRAG_DRUCK], getStatus(angebot));
            }

            return false;
        }
        function isAntragErfolgreich(angebot) {
            return _.includes([
                AppConfig.ANGEBOT.status.ANTRAG,             // 'O'
                AppConfig.ANGEBOT.status.ANTRAG_KFZ,         // 'E'
                AppConfig.ANGEBOT.status.VERTRAGSAENDERUNG,  // 'C'
                AppConfig.ANGEBOT.status.VERTRAGSANLAGE      // 'V'
            ], getStatus(angebot));
        }
        function beitraegeVorhanden(angebot) {
            return (
                !!(_.get(angebot, 'ergebnisLetzteBerechnung.gesamtergebnis') || []).length &&
                _.some(_.get(angebot, 'ergebnisLetzteBerechnung.gesamtergebnis'), function (ergebnis) {
                    return MiscUtilsService.isNotEmpty(ergebnis.gesamtBrutto) && MoneyUtilsService.getAmount(ergebnis.gesamtBrutto) > 0;
                })
            );
        }
        function getToken(angebot) {
            return _.get(angebot, 'token');
        }
        function checkSollBerechnen(angebotModel, options) {
            options = options || {};

            return !(
                (!options.ignoreAngebotAenderbar && !isAngebotAenderbar(angebotModel.angebot, 'ANGEBOT')) ||
                !!angebotModel.angebotLetzteBerechnung &&
                !hatTarifrelevanteAenderungen(angebotModel.angebot, angebotModel.angebotLetzteBerechnung, options)
            ) || !beitraegeVorhanden(angebotModel.angebot) || that.forceBerechnen;
        }
        function hatAenderungen(angebot, compareAngebot, options) {
            var angebotCopy,
                compareAngebotCopy;

            angebotCopy = _.cloneDeep(angebot);
            compareAngebotCopy = _.cloneDeep(compareAngebot);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotCopy, compareAngebotCopy)) {
                return true;
            }

            bereinigeAngebotFuerVergleich(angebotCopy, options);
            bereinigeAngebotFuerVergleich(compareAngebotCopy, options);

            return !angular.equals(angebotCopy, compareAngebotCopy);
        }
        function hatTarifrelevanteAenderungen(angebot, compareAngebot, options) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                angebotModel = AngebotModel.get(),
                properties = getTarifrelevanteAenderungProperties(angebot),
                angebotCopy,
                compareAngebotCopy;

            options = options || {};
            mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial);
            angebotCopy = _.cloneDeep(angebot);
            compareAngebotCopy = _.cloneDeep(compareAngebot);

            bereinigeAngebotFuerVergleich(angebotCopy, options);
            bereinigeAngebotFuerVergleich(compareAngebotCopy, options);
            if (CustomAngebotService.hatTarifrelevanteAenderungen(angebotCopy, compareAngebotCopy, options)) {
                return true;
            }
            if (angular.isFunction(AngebotSpezifischService.hatTarifrelevanteAenderungen)) {
                if (AngebotSpezifischService.hatTarifrelevanteAenderungen(angebotCopy, compareAngebotCopy, options)) {
                    return true;
                }
            }
            return !properties.every(function (key) {
                return _.isEqual(_.get(angebotCopy, key, null), _.get(compareAngebotCopy, key, null));
            });
        }
        function hatAenderungenFuerTarifgruppe(angebot, compareAngebot) {
            var tarifgruppeProperties = [
                    getTarifauskunftsdatumPath(angebot),
                    'antragsteller.arbeitgeber',
                    'antragsteller.beruf'
                ],
                aenderungVorhanden = false;

            if (MiscUtilsService.isEverythingEmpty(angebot, compareAngebot)) {
                return false;
            }

            if (MiscUtilsService.isAtLeastOneEmpty(angebot, compareAngebot)) {
                return true;
            }
            isPlzAntragstellerEingabeImAngebotVorhanden(angebot).then(function (plzAntragstellerEingabeImAngebotVorhanden) {
                if (plzAntragstellerEingabeImAngebotVorhanden) {
                    tarifgruppeProperties.push('antragsteller.postleitzahl');
                }
            });
            _.each(tarifgruppeProperties, function (prop) {
                if (!angular.equals(_.get(angebot, prop), _.get(compareAngebot, prop))) {
                    aenderungVorhanden = true;
                    return false;
                }
            });

            return aenderungVorhanden;
        }
        function getTarifrelevanteAenderungProperties(angebot) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            return _.union([getTarifauskunftsdatumPath(angebot)], tarifrelevanteAenderungenProperties, AngebotSpezifischService.getTarifrelevanteAenderungProperties(angebot));
        }
        function bereinigeAngebotFuerVergleich(angebot, options) {
            var vorversicherungen;

            CustomAngebotService.bereinigeAngebotFuerVergleich(angebot, options);
            MiscUtilsService.removeProperty(angebot, 'bezeichnung', true);
            MiscUtilsService.removeProperty(angebot, 'sortierKz', true);
            MiscUtilsService.removeProperty(angebot, 'verfuegbar', true);
            MiscUtilsService.removeProperty(angebot, 'uuid', true);

            _.forEach(angebotspartnerPathMap, function (angebotspartnerPath, key) {
                var kommunikationsmedien = getKommunikationsmedien(angebot, key);
                _.set(angebot, angebotspartnerPath + '.kommunikationsmedien', _.sortBy(kommunikationsmedien, ['art.wert']));
            });
            vorversicherungen = _.get(angebot, 'vorversicherungen');
            if (MiscUtilsService.isNotEmpty(vorversicherungen) && _.size(vorversicherungen) > 1) {
                _.set(angebot, 'vorversicherungen', _.sortBy(vorversicherungen, ['produkt.wert']));
            }
        }
        function getAngebotspartner(obj, angebotspartner) {
            var angebotspartnerPath = getAngebotspartnerPath(angebotspartner);

            if (!obj || !angebotspartnerPath) {
                return {};
            }

            return _.get(obj, angebotspartnerPath) || {};
        }
        function getAngebotspartnerPath(angebotspartner) {
            return angebotspartnerPathMap[_.toLower(angebotspartner)] || angebotspartner;
        }
        function getKommunikationsmedien(angebot, angebotspartner) {
            return getAngebotspartner(angebot, angebotspartner).kommunikationsmedien;
        }
        function getKommunikationsmedium(angebot, angebotspartner, komeArt) {
            var angebotspartnerKome = getAngebotspartner(angebot, angebotspartner).kommunikationsmedien;

            if (!angebotspartnerKome) {
                return null;
            }

            return _.filter(angebotspartnerKome, function (kome) {
                return _.get(kome, 'art.wert') === komeArt;
            })[0] || null;
        }
        function setKommunikationsmedium(angebot, angebotspartner, kome) {
            if (!angebot || MiscUtilsService.isAtLeastOneEmpty(angebotspartner, kome)) {
                return;
            }

            aktualisiereKommunikationsmedium(angebot, angebotspartner, kome);
        }
        function loescheKommunikationsmedium(angebot, angebotspartner, kome) {
            if (!angebot || MiscUtilsService.isAtLeastOneEmpty(angebotspartner, kome)) {
                return;
            }
            kome.wert = null;

            aktualisiereKommunikationsmedium(angebot, angebotspartner, kome);
        }
        function aktualisiereKommunikationsmedium(angebot, angebotspartner, kome) {
            var partnerKomePath = getAngebotspartnerPath(angebotspartner) + '.kommunikationsmedien',
                idx,
                komeArt,
                kommunikationsmedium,
                kommunikationsmedien;

            komeArt = _.get(kome, 'art.wert');
            kommunikationsmedium = getKommunikationsmedium(angebot, angebotspartner, komeArt);
            kommunikationsmedien = getKommunikationsmedien(angebot, angebotspartner);

            if (!kommunikationsmedium) {
                if (MiscUtilsService.isEmpty(kome.wert)) {
                    return;
                }
                if (_.isArray(kommunikationsmedien)) {
                    kommunikationsmedien.push(kome);
                } else {
                    _.set(angebot, partnerKomePath, [kome]);
                }
            } else {
                idx = _.findIndex(kommunikationsmedien, {
                    art: {
                        wert: komeArt
                    }
                });

                if (MiscUtilsService.isEmpty(kome.wert)) {
                    kommunikationsmedien.splice(idx, 1);
                } else {
                    kommunikationsmedien.splice(idx, 1, _.merge(kommunikationsmedium, kome));
                }
            }
        }
        function uebernehmeAngebotspartner(angebot, angebotspartnerFrom, angebotspartnerTo, options) {
            var angebotspartnerFromObj = _.cloneDeep(_.isObject(angebotspartnerFrom) ? angebotspartnerFrom : getAngebotspartner(angebot, angebotspartnerFrom)),
                angebotspartnerToObj = getAngebotspartner(angebot, angebotspartnerTo),
                returnValue;

            options = options || {};

            _.mergeWith(angebotspartnerToObj, angebotspartnerFromObj, function (toValue, fromValue, key) {
                if (key === 'id') {
                    return null;
                }

                if (_.includes(options.ignoreProperties, key)) {
                    if (options.ignorePropertiesOnlyIfNull) {
                        returnValue = MiscUtilsService.isEmpty(fromValue) ? toValue : fromValue;
                    } else {
                        returnValue = toValue;
                    }
                } else {
                    returnValue = fromValue;
                }

                return returnValue;
            });
        }
        function uebernehmeAntragstellerAlsPraemienzaher(angebot, ignoreProperties) {
            uebernehmeAngebotspartner(angebot, 'antragsteller', 'praemienzahler', {
                ignoreProperties: ignoreProperties ? ignoreProperties : ['iban', 'bic', 'bankname', 'bankort', 'kontonummer', 'bankleitzahl', 'ibanQualitaetscode'],
                ignorePropertiesOnlyIfNull: true
            });
        }
        function loescheAngebotspartner(angebot, angebotspartner, ignoreProperties) {
            MiscUtilsService.clearObject(getAngebotspartner(angebot, angebotspartner), ignoreProperties);
        }
        function getMaxAntragstellerGeburtsdatum(angebot) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.getMaxAntragstellerGeburtsdatum)) {
                return AngebotSpezifischService.getMaxAntragstellerGeburtsdatum(angebot);
            }

            return moment().subtract(18, 'years').format(AppConfig.API.dateFormat);
        }
        function isAngebotAnonym(angebot) {
            return MiscUtilsService.isEmpty(_.get(angebot, 'antragsteller.partnernummer.id'));
        }
        function isPlzAntragstellerEingabeImAngebotVorhanden(angebot) {
            return $q(function (resolve, reject) {
                if (_.get(angebot, 'partnerIcis.partnernummer')) {
                    AdresseUtilsService.getAdressen().then(function (adressen) {
                        var plzAntragstellerEingabeImAngebotErlaubt = (
                            (
                                adressen.length && AdresseUtilsService.getUniquePostleitzahlen(adressen).length > 1 ||
                                !adressen.length && MiscUtilsService.isEmpty(_.get(angebot, 'partnerIcis.postleitzahl'))
                            ) && AppConfig.ANGEBOT.plzAntragstellerEingabeImAngebot
                        );

                        resolve(plzAntragstellerEingabeImAngebotErlaubt);
                    }).catch(function () {
                        resolve(AppConfig.ANGEBOT.plzAntragstellerEingabeImAngebot);
                    });
                } else {
                    resolve(AppConfig.ANGEBOT.plzAntragstellerEingabeImAngebot);
                }
            });
        }
        function isDirectNavigationToStepErgebnisErlaubt(angebot, currentForm) {
            var NavigationService = $injector.get('NavigationService');

            return NavigationService.isNavigationAllowed('rechner.ergebnis', null, currentForm) && beitraegeVorhanden(angebot);
        }
        function isHinweismeldungDoppelversicherungAnzeigen(angebot, vorversicherung) {
            var versicherungsbeginn = _.get(angebot, 'allgemeineAntragsdaten.versicherungsbeginn'),
                ablaufdatumNachVersicherungsbeginn = false,
                hinweismeldungAnzeigen = false,
                hashHinweismeldungDoppelversicherung;

            vorversicherung = vorversicherung || {};

            if (!vorversicherung.vorhanden ||
                vorversicherung.beiWemBestandVorversicherung !== getConstant('vorversicherungsarten').fremdversicherung.wert ||
                MiscUtilsService.isAtLeastOneEmpty(vorversicherung.ablaufdatumDerVorversicherung, versicherungsbeginn) && vorversicherung.wurdeVertragGekuendigt ||
                MiscUtilsService.isEmpty(vorversicherung.wurdeVertragGekuendigt) ||
                !isAngebotAenderbar(angebot, 'ANTRAG')
            ) {
                hinweismeldungDoppelversicherungAngezeigtHash = null;
                return false;
            }

            ablaufdatumNachVersicherungsbeginn = moment(vorversicherung.ablaufdatumDerVorversicherung).isAfter(versicherungsbeginn);
            hashHinweismeldungDoppelversicherung = [
                vorversicherung.ablaufdatumDerVorversicherung,
                versicherungsbeginn,
                vorversicherung.wurdeVertragGekuendigt
            ].join('#');

            if (vorversicherung.wurdeVertragGekuendigt === false && hashHinweismeldungDoppelversicherung !== hinweismeldungDoppelversicherungAngezeigtHash) {
                hinweismeldungDoppelversicherungAngezeigtHash = hashHinweismeldungDoppelversicherung;
                return true;
            }

            if (ablaufdatumNachVersicherungsbeginn && hashHinweismeldungDoppelversicherung !== hinweismeldungDoppelversicherungAngezeigtHash) {
                hinweismeldungDoppelversicherungAngezeigtHash = hashHinweismeldungDoppelversicherung;
                hinweismeldungAnzeigen = true;
            } else {
                if (!ablaufdatumNachVersicherungsbeginn) {
                    hinweismeldungDoppelversicherungAngezeigtHash = null;
                }
                hinweismeldungAnzeigen = false;
            }

            return hinweismeldungAnzeigen;
        }
        function isErsatzgeschaeft(angebot) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                gegenstaende,
                ersatzgeschaeft;

            if (_.isFunction(AngebotSpezifischService.isErsatzgeschaeft)) {
                return AngebotSpezifischService.isErsatzgeschaeft(angebot);
            }

            if (!!_.get(angebot, 'ersatzgeschaeft.vertragsnummer') || !!_.get(angebot, 'vertragsnummerErsatzgeschaeft.id')) {
                return true;
            } else if (_.isFunction(CustomAngebotService.getProdukte)) {
                ersatzgeschaeft = false;

                if (AppConfig.ANGEBOT.flexibleAngebotVersion === 'PRODUKTE_AM_GEGENSTAND') {
                    gegenstaende = getGegenstaende(angebot, null, {
                        onlyActive: true,
                        asArray: true
                    });

                    _.each(gegenstaende, function (gegenstand) {
                        _.each(CustomAngebotService.getProdukte(gegenstand.gegenstand), function (produkt) {
                            if (_.get(produkt, 'ersatzgeschaeftProdukt')) {
                                ersatzgeschaeft = true;
                                return false;
                            }
                        });

                        if (ersatzgeschaeft) {
                            return false;
                        }
                    });

                    return ersatzgeschaeft;
                } else if (AppConfig.ANGEBOT.flexibleAngebotVersion === 'BAUSTEINE_AM_ANGEBOT') {
                    _.each(CustomAngebotService.getProdukte(angebot), function (produkt) {
                        if (_.get(produkt, 'ersatzgeschaeftProdukt')) {
                            ersatzgeschaeft = true;
                            return false;
                        }
                    });

                    if (ersatzgeschaeft) {
                        return false;
                    }
                }
            }

            return false;
        }
        function isDeckungsaenderung(angebot) {
            return !!_.get(angebot, 'altvertrag.vertragsnummer.id');
        }
        function getAvbVersion(angebot, produktNr) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                avbNummer,
                produkte,
                gegenstaende;

            if (angular.isFunction(AngebotSpezifischService.getAvbVersion)) {
                return AngebotSpezifischService.getAvbVersion(angebot, produktNr);
            }

            if (_.isFunction(CustomAngebotService.getProdukte)) {
                if (AppConfig.ANGEBOT.flexibleAngebotVersion === 'PRODUKTE_AM_GEGENSTAND') {
                    gegenstaende = getGegenstaende(angebot, null, {
                        onlyActive: true,
                        asArray: true
                    });

                    _.each(gegenstaende, function (gegenstand) {
                        _.each(CustomAngebotService.getProdukte(gegenstand.gegenstand), function (produkt) {
                            if (_.get(produkt, 'produkt.wert') === produktNr) {
                                avbNummer = _.get(produkt, 'avbNummer.id');

                                if (!_.isNil(avbNummer)) {
                                    return false;
                                }
                            }
                        });

                        if (!_.isNil(avbNummer)) {
                            return false;
                        }
                    });
                } else if (_.includes(['BAUSTEINE_AM_ANGEBOT', 'PRODUKTE_AM_ANGEBOT', 'BAUSTEINE_AM_GEGENSTAND'], AppConfig.ANGEBOT.flexibleAngebotVersion)) {
                    produkte = CustomAngebotService.getProdukte(angebot);

                    if (_.size(produkte) > 0) {
                        _.each(produkte, function (produkt) {
                            if (_.get(produkt, 'produkt.wert') === produktNr) {
                                avbNummer = _.get(produkt, 'avbNummer.id');

                                if (!_.isNil(avbNummer)) {
                                    return false;
                                }
                            }
                        });
                    } else {
                        gegenstaende = getGegenstaende(angebot, null, {
                            onlyActive: true,
                            asArray: true
                        });

                        _.each(gegenstaende, function (gegenstand) {
                            _.each(CustomAngebotService.getProdukte(gegenstand.gegenstand), function (produkt) {
                                if (_.get(produkt, 'produkt.wert') === produktNr) {
                                    avbNummer = _.get(produkt, 'avbNummer.id');

                                    if (!_.isNil(avbNummer)) {
                                        return false;
                                    }
                                }
                            });

                            if (!_.isNil(avbNummer)) {
                                return false;
                            }
                        });
                    }
                }
            }

            return parseInt(avbNummer, 10) || null;
        }
        function isGevo(angebot, gevo) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.isGevo)) {
                return AngebotSpezifischService.isGevo(angebot, gevo);
            }

            return false;
        }
        function getAltvertragObjekt(angebot) {
            if (isErsatzgeschaeft(angebot)) {
                return _.get(angebot, 'ersatzgeschaeft.objekte[0]') || {};
            }

            if (isDeckungsaenderung(angebot)) {
                return _.get(angebot, 'altvertrag.objekte[0]') || {};
            }

            return {};
        }
        function kopiereAngebot(angebotModel) {
            var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                angebotsToken = getToken(angebotModel.angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angKopieren, angebotsnummer, angebotsToken);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            $analytics.eventTrack('link', {
                target: 'Angebot-kopieren'
            });

            return $http({
                method: 'GET',
                url: serviceUrl
            }).then(function (response) {
                var data = response.data || {},
                    angebotModel;

                resetServiceVariables(data.angebot);
                IntegrationService.setIntegrationParams({
                    mappings: null,
                    angbestandteileAktiv: null
                });

                AngebotModel.initAngebotModel(data.angebot);
                AngebotModel.initAngebotInitial(data.angebotInitial || angebotModel.angebotInitial);
                AngebotModel.setTarif(data.tarifgeneration);

                angebotModel = AngebotModel.get();
                angebotModel.wurdeGeladen = false;
                angebotModel.wurdeKopiert = true;

                return angebotModel;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function neuesAngebotMitAntragsteller(angebotModel) {
            var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                angebotsToken = getToken(angebotModel.angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angNeuMitAntragsteller, angebotsnummer, angebotsToken);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            $analytics.eventTrack('link', {
                target: 'Neues-Angebot-mit-Antragsteller'
            });

            return $http({
                method: 'POST',
                url: serviceUrl
            }).then(function (response) {
                var data = response.data || {};

                resetServiceVariables(data);
                IntegrationService.setIntegrationParams({
                    mappings: null,
                    angbestandteileAktiv: null
                });

                AngebotModel.initAngebotModel(data);
                AngebotModel.initAngebotInitial(data);
                angebotModel.wurdeGeladen = false;
                angebotModel.wurdeKopiert = false;
                AngebotModel.setTarif(angebotModel.tarif);

                return AngebotModel.get();
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function erstelleNeuesAngebot(angebotModel) {
            AngebotModel.init(angebotModel.angebotInitial);

            resetServiceVariables(angebotModel.angebot);
            angebotModel.wurdeGeladen = false;
            _.unset(angebotModel, 'showTarifWechselModal');

            return AngebotModel.get();
        }
        function setDateiAnhang(angebot, dateiAnhang) {
            var dateiAnhaenge = _.get(angebot, 'anhaenge');

            if (MiscUtilsService.isEmpty(dateiAnhang)) {
                return;
            }

            _.set(angebot, 'anhaenge', _.unionBy(dateiAnhaenge, [dateiAnhang], 'id'));
        }
        function removeDateiAnhang(angebot, dateiAnhangId) {
            var dateiAnhaenge = _.get(angebot, 'anhaenge');

            if (MiscUtilsService.isEmpty(dateiAnhangId)) {
                return;
            }

            _.set(angebot, 'anhaenge', _.reject(dateiAnhaenge, ['id', dateiAnhangId]));
        }
        function getGesamtbeitragZuZahlweise(angebot, berechnungDurchSummierung, beitragProperty) {
            beitragProperty = beitragProperty || 'brutto';

            if (_.isFunction(CustomAngebotService.getGesamtbeitragZuZahlweise) && berechnungDurchSummierung) {
                return CustomAngebotService.getGesamtbeitragZuZahlweise(angebot, beitragProperty);
            }

            var zahlweiseWert = getZahlweise(angebot).wert;

            return (_.find(_.get(angebot, 'ergebnisLetzteBerechnung.gesamtergebnis'), {
                zahlweise: {
                    wert: zahlweiseWert
                }
            }) || {}).gesamtBrutto;
        }
        function getMoeglicheZahlweisen(angebotModel, onlyIfBeitragExists) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.getMoeglicheZahlweisen)) {
                return AngebotSpezifischService.getMoeglicheZahlweisen(angebotModel, onlyIfBeitragExists);
            } else {
                return [];
            }
        }
        function getZahlweise(angebot) {
            var zahlweise = _.get(angebot, 'zahlungsinformationen.zahlweise') || {},
                mappedZahlweise = _.find(AppConfig.ANGEBOT.zahlweisen, ['wert', zahlweise.wert]);

            return mappedZahlweise || zahlweise;
        }
        function setZahlweise(angebot, zahlweise) {
            _.set(angebot, 'zahlungsinformationen.zahlweise', zahlweise);
        }
        function isEinmalZahlung(angebot) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.isEinmalZahlung)) {
                return AngebotSpezifischService.isEinmalZahlung(angebot);
            } else {
                return false;
            }
        }
        function isRechnungBeiZahlweiseErlaubt(angebot) {
            var altvertragObjekt = getAltvertragObjekt(angebot);

            return (
                _.includes([
                    AppConfig.ANGEBOT.zahlweisen.VIERTELJAEHRLICH.wert,
                    AppConfig.ANGEBOT.zahlweisen.MONATLICH.wert
                ], _.get(altvertragObjekt, 'zahlweise.wert'))
            );
        }
        function korrigiereZahlweise(angebotModel, checkIfBeitragExists) {
            var zahlweise = getZahlweise(angebotModel.angebot),
                configZahlweisen = AppConfig.ANGEBOT.zahlweisen,
                einmalZahlweise = SchluesselWerteUtilsService.create('ZAHLWEISE', configZahlweisen.EINMAL.wert, configZahlweisen.EINMAL.bezeichnung),
                jahresZahlweise = SchluesselWerteUtilsService.create('ZAHLWEISE', configZahlweisen.JAEHRLICH.wert, configZahlweisen.JAEHRLICH.bezeichnung),
                moeglicheZahlweisen = getMoeglicheZahlweisen(angebotModel, checkIfBeitragExists),
                einmalZahlung = isEinmalZahlung(angebotModel.angebot);

            if (einmalZahlung && zahlweise && !_.isEqual(zahlweise.wert, einmalZahlweise.wert)) {
                setZahlweise(angebotModel.angebot, einmalZahlweise);
            } else if (!einmalZahlung && zahlweise && _.isEqual(zahlweise.wert, einmalZahlweise.wert)) {
                setZahlweise(angebotModel.angebot, jahresZahlweise);
            } else if (moeglicheZahlweisen.length === 1 && !_.isEqual(zahlweise.wert, moeglicheZahlweisen[0].wert)) {
                setZahlweise(angebotModel.angebot, moeglicheZahlweisen[0]);
            } else if (moeglicheZahlweisen.length > 1 && MiscUtilsService.isEmpty(_.find(moeglicheZahlweisen, { wert: zahlweise.wert })) && MiscUtilsService.isNotEmpty(_.find(moeglicheZahlweisen, { wert: jahresZahlweise.wert }))) {
                setZahlweise(angebotModel.angebot, jahresZahlweise);
            }
        }
        function getMoeglicheTarifarten(obj, bausteinKey) {
            return _.get(obj, bausteinKey + '.moeglicheTarifarten', []);
        }
        function sortiereTarifarten(tarifarten) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(AngebotModel.get().angebot) + 'Service'),
                anzahlTarifarten = _.size(tarifarten),
                orderTarifarten = {
                    S: anzahlTarifarten === 2 ? 1 : 1,
                    B: anzahlTarifarten === 2 ? 0 : 0,
                    P: 2
                };

            if (_.isFunction(AngebotSpezifischService.sortiereTarifarten)) {
                return AngebotSpezifischService.sortiereTarifarten(tarifarten);
            }

            return _.sortBy(tarifarten, function (tarifart) {
                var tarifartWert = _.get(tarifart, 'wert');

                return orderTarifarten[tarifartWert];
            });
        }
        function hasBausteinTarifarten(obj, bausteinKey) {
            return getMoeglicheTarifarten(obj, bausteinKey).length > 1;
        }
        function getBausteinTarifart(angebot, obj, bausteinKey, key) {
            key = key || 'wert';

            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService['get' + _.upperFirst(bausteinKey) + 'Tarifart'])) {
                return _.get(AngebotSpezifischService['get' + _.upperFirst(bausteinKey) + 'Tarifart'](angebot), key);
            }

            return _.get(obj, bausteinKey + '.tarifartModellierung.' + key);
        }
        function setBausteinTarifart(obj, bausteinKey, tarifart, options) {
            options = options || {};

            var neueTarifart = _.find(getMoeglicheTarifarten(obj, bausteinKey), {
                wert: tarifart
            });
            if (MiscUtilsService.isEmpty(neueTarifart) && options.onlyAvailable !== true) {
                neueTarifart = SchluesselWerteUtilsService.create('TARIFART', tarifart);
            }

            if (neueTarifart) {
                _.set(obj, bausteinKey + '.tarifartModellierung', neueTarifart);
            }
        }
        function aktualisiereTarifart(obj, tarifart, bausteinKeys, options) {
            bausteinKeys = bausteinKeys || getBausteineKeys(obj);

            _.each(bausteinKeys, function (bausteinKey) {
                setBausteinTarifart(obj, bausteinKey, tarifart, options);
            });
        }
        function deaktiviereBausteinTarifartNichtMoeglich(obj, bausteinKeys) {
            bausteinKeys = bausteinKeys || getBausteineKeys(obj);

            var moeglicheTarifarten,
                tarifartMoeglich = true,
                tarifartModellierungWert;

            _.each(bausteinKeys, function (bausteinKey) {
                moeglicheTarifarten = getMoeglicheTarifarten(obj, bausteinKey);
                if (MiscUtilsService.isEmpty(moeglicheTarifarten) || !isBausteinAktiv(obj, bausteinKey)) {
                    return false;
                }

                tarifartModellierungWert = _.get(obj, bausteinKey + '.tarifartModellierung.wert');

                tarifartMoeglich = !!_.find(getMoeglicheTarifarten(obj, bausteinKey), {
                    wert: tarifartModellierungWert
                });

                if (!tarifartMoeglich) {
                    setBausteinAktiv(bausteinKey, false, obj);
                }
            });
        }
        function setBausteinAktiv(baustein, aktiv, obj) {
            var bausteinObj = baustein;

            if (_.isString(baustein) && MiscUtilsService.isNotEmpty(obj)) {
                bausteinObj = _.get(obj, baustein);
            }

            if (bausteinObj) {
                bausteinObj.aktiv = !!aktiv;
            }
        }
        function setBausteinSbLg(obj, bausteinKey, sbLg) {
            var sbLgType = _.get(sbLg, 'code.type'),
                path;

            if (sbLgType === 'SELBSTBETEILIGUNGSCODE') {
                path = 'selbstbeteiligung';
            } else if (sbLgType === 'LEISTUNGSGRENZENCODE') {
                path = 'leistungsgrenze';
            }

            if (_.isString(bausteinKey)) {
                _.set(obj, bausteinKey + '.' + path, sbLg);
            } else if (_.isObject(bausteinKey)) {
                _.set(bausteinKey, path, sbLg);
            }
        }
        function resetBeitraege(obj, resetAllBrutto) {
            _.set(obj, 'ergebnisLetzteBerechnung.tarifrechnerergebnisZeilen', []);
            _.set(obj, 'ergebnisLetzteBerechnung.gesamtergebnis', []);

            if (resetAllBrutto) {
                MiscUtilsService.removeProperty(obj, 'brutto', true);
            }
        }
        function resetBaustein(baustein, angebot, angebotInitial, ignoreProperties) {
            var bausteineKeys = _.isString(baustein) ? baustein.split() : _.isRegExp(baustein) ? getBausteineKeys(angebot, baustein) : baustein;

            ignoreProperties = ignoreProperties || [];
            ignoreProperties.push('zasZapAnfrageErgebnis');
            ignoreProperties.push('leistungsgrenze');
            ignoreProperties.push('selbstbeteiligung');

            _reset(bausteineKeys, angebot, angebotInitial, _.union(ignoreProperties));
        }
        function resetGegenstand(gegenstand, angebot, angebotInitial) {
            var gegenstaendeKeys = _.isString(gegenstand) ? gegenstand.split() : _.isRegExp(gegenstand) ? getGegenstaendeKeys(angebot, gegenstand) : gegenstand;

            _reset(gegenstaendeKeys, angebot, angebotInitial);
        }
        function resetBestandteil(bestandteil, angebot, angebotInitial, ignoreProperties) {
            var bestandteileKeys = _.isString(bestandteil) ? bestandteil.split() : bestandteil;

            _reset(bestandteileKeys, angebot, angebotInitial, ignoreProperties);
        }
        function isBausteinAktiv(obj, baustein) {
            if (_.isString(baustein)) {
                return _.get(obj, baustein + '.aktiv') || false;
            } else {
                return _.get(baustein, 'aktiv') || false;
            }
        }
        function leereInaktiveBausteine(angebot) {
            if (MiscUtilsService.isEmpty(angebot)) {
                return;
            }

            var bausteinKeys = getBausteineKeys(angebot),
                baustein;

            _.map(bausteinKeys, function (bausteinKey) {
                baustein = _.get(angebot, bausteinKey);

                if (!_.get(baustein, 'aktiv')) {
                    MiscUtilsService.clearObject(baustein, ['aktiv']);
                }
            });
        }
        function loescheInaktiveBausteine(angebot) {
            if (MiscUtilsService.isEmpty(angebot)) {
                return;
            }

            var bausteinKeys = getBausteineKeys(angebot);

            _.map(bausteinKeys, function (prop) {
                if (!_.get(angebot, prop + '.aktiv')) {
                    _.unset(angebot, prop);
                }
            });
        }
        function isTarifartAktiv(obj, bausteinKey, tarifart) {
            if (_.isString(bausteinKey)) {
                return _.isEqual(_.get(obj, bausteinKey + '.tarifartModellierung.wert'), tarifart);
            } else {
                return _.isEqual(_.get(bausteinKey, 'tarifartModellierung.wert'), tarifart);
            }
        }
        function getDeckungscode(obj, bausteinKey) {
            return _.get(obj, bausteinKey + '.deckungscode.wert');
        }
        function setDeckungscode(obj, bausteinKey, deckungscode) {
            if (MiscUtilsService.isAtLeastOneEmpty(obj, bausteinKey, deckungscode)) {
                return;
            }

            var baustein = obj[bausteinKey];

            baustein.deckungscode = SchluesselWerteUtilsService.create('DECKUNGSCODE', deckungscode);
        }
        function getAngebotsdatumRegeln(angebot) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (AngebotSpezifischService && _.isFunction(AngebotSpezifischService.getAngebotsdatumRegeln)) {
                return AngebotSpezifischService.getAngebotsdatumRegeln(angebot);
            }

            return {
                min: _.get(angebot, 'rahmenDaten.angebotsdatumMin', ''),
                max: _.get(angebot, 'rahmenDaten.angebotsdatumMax', '')
            };
        }
        function getVersicherungsbeginnRegeln(angebot) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                angebotsdatumRegeln = getAngebotsdatumRegeln(angebot),
                tarifauskunftsdatumType = getTarifauskunftsdatumType(angebot),
                sysdate = moment(),
                versicherungsbeginnRegeln,
                isRueckgewinnungsAngebot = false,
                datum,
                datumPath,
                maxDate,
                minDate;

            if (tarifauskunftsdatumType === 'tarifauskunftsdatum' && MiscUtilsService.isEmpty(_.get(angebot, 'allgemeineDaten.angebotsdatum'))) {
                return {
                    min: null,
                    max: null
                };
            }

            datumPath = getTarifauskunftsdatumPath(angebot);
            isRueckgewinnungsAngebot = hasAngebotsart(angebot, null, AppConfig.ANGEBOT.angebotsarten.RUECKGEWINNUNG);

            if (isRueckgewinnungsAngebot) {
                maxDate = moment(angebot.stichtagTarif, AppConfig.API.dateFormat).endOf('year').format(AppConfig.API.dateFormat);
            } else if (AppConfig.ANGEBOT.versicherungsbeginnRegel === '360_DAYS' && moment().add(360, 'days').isAfter(moment(angebotsdatumRegeln.max, AppConfig.API.dateFormat))) {
                maxDate = moment().add(360, 'days').format(AppConfig.API.dateFormat);
            } else {
                maxDate = angebotsdatumRegeln.max;
            }

            if (AngebotSpezifischService && _.isFunction(AngebotSpezifischService.getVersicherungsbeginnRegeln)) {
                versicherungsbeginnRegeln = AngebotSpezifischService.getVersicherungsbeginnRegeln(angebot);

                if (isRueckgewinnungsAngebot) {
                    versicherungsbeginnRegeln.max = maxDate || angebotsdatumRegeln.max;
                }

                return versicherungsbeginnRegeln;
            }

            if (tarifauskunftsdatumType === 'tarifauskunftsdatum') {
                datum = moment(_.get(angebot, datumPath), AppConfig.API.dateFormat) || moment();
                minDate = datum.diff(sysdate, 'days') === 0 ? moment().add(1, 'days') : datum;
            } else {
                minDate = moment(angebotsdatumRegeln.min, AppConfig.API.dateFormat).isAfter(moment().add(1, 'days')) ? moment(angebotsdatumRegeln.min, AppConfig.API.dateFormat) : moment().add(1, 'days');
            }

            return {
                min: minDate.format(AppConfig.API.dateFormat),
                max: maxDate || angebotsdatumRegeln.max
            };
        }
        function setVersicherungsbeginn(angebot, onlyIfOutsideRules) {
            var versicherungsbeginnRegeln = getVersicherungsbeginnRegeln(angebot),
                versicherungsbeginn = _.get(angebot, 'allgemeineAntragsdaten.versicherungsbeginn'),
                versicherungsbeginnMoment = moment(versicherungsbeginn, AppConfig.API.dateFormat);

            if (MiscUtilsService.isEverythingNotEmpty(versicherungsbeginn && versicherungsbeginnRegeln.min)) {
                if (_.isNil(onlyIfOutsideRules) || onlyIfOutsideRules === false) {
                    _.set(angebot, 'allgemeineAntragsdaten.versicherungsbeginn', versicherungsbeginnRegeln.min);
                } else if (onlyIfOutsideRules) {
                    if (versicherungsbeginnMoment.isBefore(moment(versicherungsbeginnRegeln.min, AppConfig.API.dateFormat))) {
                        _.set(angebot, 'allgemeineAntragsdaten.versicherungsbeginn', versicherungsbeginnRegeln.min);
                    } else if (versicherungsbeginnMoment.isAfter(moment(versicherungsbeginnRegeln.max, AppConfig.API.dateFormat))) {
                        _.set(angebot, 'allgemeineAntragsdaten.versicherungsbeginn', versicherungsbeginnRegeln.max);
                    } else {
                    }
                }
            }
        }
        function getKonditionen(angebot, produktNrFilter) {
            return CustomAngebotService.getKonditionen(angebot, produktNrFilter);
        }
        function isKonditionVorhanden(angebot, konditionscodeId) {
            return CustomAngebotService.isKonditionVorhanden(angebot, konditionscodeId);
        }
        function sortBausteine(angebot, bausteine, produktGruppe) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                idx;

            return _.sortBy(bausteine, function (baustein) {
                idx = _.indexOf(AngebotSpezifischService.getAlleBausteineSortiertByProduktGruppe()[produktGruppe], baustein.bausteinKey);

                if (idx < 0) {
                    idx = _.size(bausteine) + _.indexOf(bausteine, baustein.bausteinKey);
                }

                return idx;
            });
        }
        function getVorversicherungen(angebot, produktNrFilter) {
            return CustomAngebotService.getVorversicherungen(angebot, produktNrFilter);
        }
        function isVorversicherungValide(vorversicherung) {
            var merkmalePflicht = [],
                isValid = true;

            vorversicherung = vorversicherung || {};

            if (vorversicherung.vorhanden === false) {
                return true;
            }

            merkmalePflicht.push('beiWemBestandVorversicherung');

            if (vorversicherung.beiWemBestandVorversicherung === getConstant('vorversicherungsarten.unternehmen.wert')) {
                merkmalePflicht.push('unternehmenVersicherungsscheinnummer');
            } else {
                merkmalePflicht.push('beiWemBestandVorversicherungGesellschaft');
                merkmalePflicht.push('fremdgesellschaftVersicherungsscheinnummer');
                merkmalePflicht.push('wurdeVertragGekuendigt');

                if (vorversicherung.wurdeVertragGekuendigt) {
                    merkmalePflicht.push('ablaufdatumDerVorversicherung');
                    merkmalePflicht.push('wurdeVertragGekuendigtVomVu');
                }
            }

            _.each(merkmalePflicht, function (merkmalPflicht) {
                if (MiscUtilsService.isEmpty(_.get(vorversicherung, merkmalPflicht))) {
                    isValid = false;
                    return false;
                }
            });

            return isValid;
        }
        function isBestandskunde(angebot) {
            return (
                AuthenticationService.isTokenLogin() ||
                !isAngebotAnonym(angebot) ||
                _.size(_.filter(getVorversicherungen(angebot), {
                    vorhanden: true,
                    beiWemBestandVorversicherung: getConstant('vorversicherungsarten.unternehmen.wert')
                })) > 0
            );
        }
        function isUploadAvailable(angebotModel) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service'),
                isAvailable = (
                    modernizr.xhr2 &&
                    AuthenticationService.hatBerechtigung('ANG_DATEI_HOCHLADEN')
                );

            if (!isAvailable) {
                return false;
            }

            if (_.isFunction(AngebotSpezifischService.isUploadAvailable)) {
                return AngebotSpezifischService.isUploadAvailable(angebotModel);
            }

            return true;
        }

        function getStatusAntrag(angebotModel, angnummer, angtoken) {
            var angebotsnummer = angnummer || getAngebotsnummer(angebotModel.angebot),
                angebotsToken = angtoken || getToken(angebotModel.angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angStatusAntrag, angebotModel.tarif.tarifkuerzel, angebotsnummer, angebotsToken);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, angebotModel.tarif.tarifkuerzel, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http.get(serviceUrl, {
                cache: false
            }).then(function (response) {
                return response.data;
            });
        }
        function getNachrichtenAbschluss(angebotModel) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service');

            if (angular.isFunction(AngebotSpezifischService.getNachrichtenAbschluss)) {
                return AngebotSpezifischService.getNachrichtenAbschluss(angebotModel);
            } else {
                return $q(function (resolve) {
                    resolve([]);
                });
            }
        }

        function getErlaubteInkassoarten(excludeList) {
            var inkassoarten = getConstant('inkassoarten');
            $log.log(inkassoarten);

            return _.filter(inkassoarten, function (val) {
                if (MiscUtilsService.isNotEmpty(excludeList) && _.includes(excludeList, val.wert)) {
                    return false;
                }

                return _.includes(AppConfig.ANGEBOT.inkassoarten, val.wert);
            });
        }

        function groupAntragVorbereiten(angebotModel, angebotScope) {
            var AngebotSpezifischService = getDIReference(getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service');

            if (angular.isFunction(AngebotSpezifischService.groupAntragVorbereiten)) {
                return AngebotSpezifischService.groupAntragVorbereiten(angebotModel, angebotScope);
            }
        }
        function isKontaktErlaubtPartner(angebotModel) {
            var angebotsnummer = getAngebotsnummer(angebotModel.angebot),
                angebotsToken = getToken(angebotModel.angebot),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.uwgEinwilligung, angebotsnummer, angebotsToken);

            if (isAngebotAnonym(angebotModel.angebot)) {
                return $q.resolve(true);
            }

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken)) {
                return $q.resolve(null);
            }

            return $http({
                method: 'GET',
                url: serviceUrl,
                cache: true,
                globalErrorsIgnore: {
                    errors: true
                }
            }).then(function (response) {
                return response.data;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function isKopierenErlaubt(angebotModel) {
            return (
                _.includes([AppConfig.ANGEBOT.status.GEDRUCKT, AppConfig.ANGEBOT.status.ANTRAG_DRUCK, AppConfig.ANGEBOT.status.GEDRUCKT_TEILWEISE_AENDERBAR], getStatus(angebotModel.angebot)) &&
                _.get(angebotModel.angebot, 'kopierenBlockiert') !== true &&
                _.get(angebotModel, 'wurdeGeladen') !== true
            );
        }
        function getAngebotsart(angebot, produktNr) {
            var gegenstaende,
                angebotsarten = {};

            produktNr = produktNr || [];

            if (_.isFunction(CustomAngebotService.getProdukte)) {
                if (AppConfig.ANGEBOT.flexibleAngebotVersion === 'PRODUKTE_AM_GEGENSTAND') {
                    gegenstaende = getGegenstaende(angebot, null, {
                        onlyActive: true,
                        asArray: true
                    });

                    _.each(gegenstaende, function (gegenstand) {
                        _.each(CustomAngebotService.getProdukte(gegenstand.gegenstand), function (produkt) {
                            if (_.get(produkt, 'angebotsart') && (_.includes(produktNr, _.get(produkt, 'produkt.wert')) || _.size(produktNr) === 0)) {
                                if (_.isArray(angebotsarten['produkt' + _.get(produkt, 'produkt.wert')])) {
                                    angebotsarten['produkt' + _.get(produkt, 'produkt.wert')].push({
                                        gegenstand: gegenstand.gegenstand,
                                        angebotsart: _.get(produkt, 'angebotsart')
                                    });
                                } else {
                                    angebotsarten['produkt' + _.get(produkt, 'produkt.wert')] = [{
                                        gegenstand: gegenstand.gegenstand,
                                        angebotsart: _.get(produkt, 'angebotsart')
                                    }];
                                }
                            }
                        });
                    });
                } else {
                    _.each(CustomAngebotService.getProdukte(angebot), function (produkt) {
                        if (_.get(produkt, 'angebotsart') && (_.includes(produktNr, _.get(produkt, 'produkt.wert')) || _.size(produktNr) === 0)) {
                            angebotsarten['produkt' + _.get(produkt, 'produkt.wert')] = {
                                angebotsart: _.get(produkt, 'angebotsart')
                            };
                        }
                    });
                }
            }

            return angebotsarten;
        }
        function hasAngebotsart(angebot, produktNr, angebotsart) {
            var angebotsarten = getAngebotsart(angebot, produktNr);

            function _findAngebotsart(angebotsarten, angebotsart) {
                var retVal = false;

                _.each(angebotsarten, function (val, key) {
                    if (_.isArray(val)) {
                        retVal = _findAngebotsart(val, angebotsart);
                    } else {
                        if (_.get(val, 'angebotsart') === angebotsart) {
                            retVal = true;
                            return false;
                        }
                    }
                });

                return retVal;
            }

            return _findAngebotsart(angebotsarten, angebotsart);
        }
        function filterNachrichten(nachrichten) {
            return _.filter(nachrichten, function (nachricht) {
                return !_.includes(AppConfig.ANGEBOT.apiNachrichtenFilter, _.get(nachricht, 'id'));
            });
        }

        function setSepaMandatErlaubt(isSepaMandatErlaubt) {
            sepaMandatErlaubt = isSepaMandatErlaubt;
        }

        function isSepaMandatErlaubt() {
            return sepaMandatErlaubt;
        }
        function getTarifauskunftsdatumType() {
            return AppConfig.ANGEBOT.tarifauskunftsdatumType || 'tarifauskunftsdatum';
        }
        function getTarifauskunftsdatumPath() {
            return getTarifauskunftsdatumType() === 'versicherungsbeginn' ? 'allgemeineAntragsdaten.versicherungsbeginn' : 'allgemeineDaten.angebotsdatum';
        }
        function getTarifauskunftsdatum(angebot) {
            var datumPath = getTarifauskunftsdatumPath(angebot);

            return _.get(angebot, datumPath);
        }
        function setTarifauskunftsdatum(angebot, tarifauskunftsdatum) {
            var datumPath = getTarifauskunftsdatumPath(angebot);

            _.set(angebot, datumPath, tarifauskunftsdatum);
            if (getTarifauskunftsdatumType(angebot) === 'versicherungsbeginn') {
                if (isAngebotAenderbar(angebot, 'ANGEBOT')) {
                    _.set(angebot, 'allgemeineDaten.angebotsdatum', tarifauskunftsdatum);
                } else {
                    $log.debug('Angebotsdatum kann nicht aktualisiert werden, da das Angebot nicht änderbar ist');
                }
            }
        }
        function getDefaultTarifauskunftsdatum(angebot) {
            if (getTarifauskunftsdatumType(angebot) === 'versicherungsbeginn') {
                return moment().add(1, 'days').format(AppConfig.API.dateFormat);
            } else {
                return moment().format(AppConfig.API.dateFormat);
            }
        }

        function setBeitragsanpassungMessage(beitragsanpassungMessage) {
            beitragsanpassungMessage = beitragsanpassungMessage || {};

            if (!_.find(beitragsanpassungMessages, ['reason', beitragsanpassungMessage.reason])) {
                beitragsanpassungMessages.push(beitragsanpassungMessage);
            }
        }

        function getBeitragsanpassungMessage(reason) {
            return _.find(beitragsanpassungMessages, ['reason', reason]);
        }
    }

})();
